(() => {
  const match = location.pathname.match(/\/products\/([^/?#]+)/);
  const handle = match ? match[1] : '';
  const params = new URLSearchParams(location.search);
  if (!window.SmoofProductProfiles?.isTestProfile?.(handle) || params.get('smoof_ui') === 'off') return;
  if (window.__smoofModernUiShellV39) return;
  window.__smoofModernUiShellV39 = true;
  window.__smoofModernUiShellV38 = true;
  window.__smoofModernUiShellV37 = true;
  window.__smoofModernUiShellV36 = true;
  window.__smoofModernUiShellV35 = true;
  window.__smoofModernUiShellV34 = true;
  window.__smoofModernUiShellV33 = true;
  window.__smoofModernUiShellV32 = true;
  window.__smoofModernUiShellV31 = true;
  window.__smoofModernUiShellV30 = true;
  window.__smoofModernUiShellV29 = true;
  window.__smoofModernUiShellV28 = true;
  window.__smoofModernUiShellV27 = true;
  window.__smoofModernUiShellV26 = true;
  window.__smoofModernUiShellV25 = true;
  window.__smoofModernUiShellV24 = true;
  window.__smoofModernUiShellV23 = true;
  window.__smoofModernUiShellV22 = true;
  window.__smoofModernUiShellV21 = true;
  window.__smoofModernUiShellV20 = true;
  window.__smoofModernUiShellV19 = true;

  const root = document.documentElement;
  root.dataset.smoofThemeUiRuntime = 'v2-39-percent-input-focus-20260905-299';
  const profile = window.SmoofProductProfiles?.current || null;
  const backgroundLocked = profile?.editorPolicy?.backgroundLocked === true;
  const laserMonochromeActive = () => {
    const policyState = window.SmoofDotMePolicy?.isMonochromeActive?.();
    if (typeof policyState === 'boolean') return policyState;
    return profile?.editorPolicy?.forceMonochromeLaser === true &&
      window.SmoofProductVariant?.get?.()?.printProcess === 'laser';
  };
  const laserVectorLogoRequired = laserMonochromeActive;
  const mobile = window.matchMedia('(max-width: 749px)');
  const SELECT_EVENT = 'smoof:editor-select';
  let selectedId = '';
  let source = null;
  let commandbar = null;
  let commandbarHost = null;
  let commandbarFlowParent = null;
  let helpWasOpenOnPointerDown = false;
  let resetWasOpenOnPointerDown = false;
  let context = null;
  let layers = null;
  let layersOpen = false;
  let layersPage = 'list';
  let layersTransitionTimer = 0;
  let suppressSelectionRenderId = '';
  let suppressSelectionRenderUntil = 0;
  let addShortcutPointerHandledUntil = 0;
  let mobileCanvasPointer = null;
  let historyCurrent = null;
  let historyCurrentKey = '';
  let historyPast = [];
  let historyFuture = [];
  let historyTimer = 0;
  let historyBaselineTimer = 0;
  let historyRestoring = false;
  let fontPickerTarget = '';
  let fontPickerInitialFamily = '';
  let templateCategory = '';
  let pictogramPickerOpenFor = '';
  const pictogramPickerCategory = { left: 'arrows', right: 'arrows' };
  const pictogramCategoryScroll = Object.create(null);
  let templateCoachmark = null;
  let templateCoachmarkTimer = 0;
  let templateCoachmarkAcknowledged = false;
  const panelScrollCleanups = new WeakMap();
  const TEMPLATE_COACHMARK_KEY = 'smoof-template-coachmark-v1';
  const DESIGN_OPTION_ID = '3474d16c-f4b6-4517-8f74-f88c27e5c914';
  const PERSONALIZED_VALUE_ID = '29cd05e6-2ef9-4956-89ef-35326fccfd1c';
  const FONT_OPTION_ID = '052c068b-772b-4d04-af0d-56214e55cce3';
  const HISTORY_LIMIT = 40;
  const HISTORY_OPTION_IDS = [
    '052c068b-772b-4d04-af0d-56214e55cce3',
    '2375ec9f-695e-489a-ae63-4dc66fbcbb3f',
    '8cbb313f-ef10-40a4-a711-b894c8c15c2f',
    '1b10591e-29cb-455c-a22f-5d534a275702',
    '5f47cc89-1d8f-4089-9919-514d4d1d3640',
    '999ff02f-9bc5-4ddf-996d-98459628780d',
    'f9b38c60-cd0d-4740-94a4-5b235d7ab60c',
    'aa1edcda-2cc3-4d6f-affd-d2db797ab684',
    'c3b03f1a-c9a4-495e-b138-51bde4cfcbe8',
    'dace7c47-c686-47bc-8580-4444848e6190',
    'dcde59d1-5fef-4e99-8d22-30e2ec19197e',
    '331a45ae-bd3d-4b85-8c7f-a8cbf014b032',
    '1f69ffa6-f179-46de-8ee6-5a90ac70558f',
    '3d6f15f5-b6a7-44d8-8e66-d80fe15b7603',
    '45b6444d-2b8c-431d-9594-91a6ab688d18',
    'f0b04c23-daf0-420c-9572-6d05e339241e',
    '5e5d6fe5-7f13-4891-9903-9ad8949dbb95',
    '3f615f11-8440-41a9-af77-fe79452d77f1'
  ];

  function optionRoot(id) {
    const roots = Array.from(document.querySelectorAll(`[data-option-id="${id}"]`));
    return roots.find(candidate => candidate.offsetParent !== null) || roots[0] || null;
  }

  function cleanFontFamily(value) {
    return String(value || '')
      .replace(/["']/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 100);
  }

  function selectedGoogleFont() {
    const option = optionRoot(FONT_OPTION_ID);
    return cleanFontFamily(
      option?.querySelector('select')?.value ||
      option?.querySelector('input[type="hidden"]')?.value ||
      option?.querySelector('button[aria-haspopup="listbox"]')?.innerText ||
      ''
    );
  }

  function rawFontForItem(itemId) {
    if (/^custom-text-[1-3]$/.test(itemId)) {
      return window.SmoofCustomTextTools?.getState?.(itemId)?.fontFamily || selectedGoogleFont() || 'Roboto';
    }
    if (/^text-[0-2]$/.test(itemId)) {
      return window.SmoofTextTools?.getFont?.(Number(itemId.split('-')[1])) || selectedGoogleFont() || 'Roboto';
    }
    if (itemId === 'table-number') {
      return window.SmoofNumberHistory?.getFont?.() || selectedGoogleFont() || 'Roboto';
    }
    return selectedGoogleFont() || 'Roboto';
  }

  function fontForItem(itemId) {
    const family = rawFontForItem(itemId);
    return window.SmoofCustomFontRegistry?.labelFor?.(family) || family;
  }

  function customFontSelected(itemId) {
    return Boolean(
      window.SmoofCustomFontRegistry?.isCustomFamily?.(
        rawFontForItem(itemId)
      )
    );
  }

  function setNativeValue(input, value, commit = false) {
    if (!input) return false;
    const prototype = input instanceof HTMLSelectElement
      ? HTMLSelectElement.prototype
      : input instanceof HTMLTextAreaElement
      ? HTMLTextAreaElement.prototype
      : HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(prototype, 'value');
    if (descriptor && descriptor.set) descriptor.set.call(input, value);
    else input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    if (commit) input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function personalizedDesignSelected() {
    const roots = Array.from(document.querySelectorAll(`[data-option-id="${DESIGN_OPTION_ID}"]`));
    const checked = roots
      .flatMap(option => Array.from(option.querySelectorAll('input[type="checkbox"], input[type="radio"]')))
      .find(input => input.checked);
    if (!checked) return false;
    if (checked.value === PERSONALIZED_VALUE_ID) return true;
    const label = checked.closest('label')?.textContent || checked.parentElement?.textContent || '';
    return /Personalisiertes Design|Personalized Design/i.test(label);
  }

  function captureOptionState(id) {
    const rootNode = optionRoot(id);
    if (!rootNode) return null;

    const choices = Array.from(rootNode.querySelectorAll('input[type="radio"], input[type="checkbox"]'));
    if (choices.length) {
      return {
        kind: 'choice',
        values: choices.filter(input => input.checked).map(input => input.value)
      };
    }

    const control = rootNode.querySelector([
      'select',
      'textarea',
      'input[type="color"]',
      'input[type="text"]',
      'input[type="search"]'
    ].join(',')) || rootNode.querySelector('input[type="hidden"]');

    return control
      ? { kind: control.tagName.toLowerCase(), type: control.type || '', value: control.value }
      : null;
  }

  function captureHistorySnapshot() {
    const options = {};
    HISTORY_OPTION_IDS.forEach(id => {
      const value = captureOptionState(id);
      if (value) options[id] = value;
    });

    return {
      options,
      textLayout: window.SmoofTextTools?.getHistoryState?.() || null,
      textVisibility: window.SmoofTextVisibility
        ? [0, 1, 2].map(index => window.SmoofTextVisibility.isVisible(index) !== false)
        : null,
      logo: window.SmoofLogoHistory?.getState?.() || null,
      logoCopy: window.SmoofLogoCopyTools?.getHistoryState?.() || null,
      logoDuplicate: window.SmoofLogoDuplicateTools?.getHistoryState?.() || null,
      logoInversion: window.SmoofLogoInvertTools?.getHistoryState?.() || null,
      logoBackgrounds: window.SmoofLogoBackgroundTools?.getHistoryState?.() || null,
      number: window.SmoofNumberHistory?.getState?.() || null,
      arrows: window.SmoofArrowTools?.getHistoryState?.() || null,
      payments: window.SmoofPaymentTools?.getHistoryState?.() || null,
      socialPlatforms: window.SmoofSocialPlatformTools?.getHistoryState?.() || null,
      customTexts: window.SmoofCustomTextTools?.getHistoryState?.() || null,
      customPictograms: window.SmoofCustomPictogramTools?.getHistoryState?.() || null,
      qrGeometry: window.SmoofQrGeometryTools?.getHistoryState?.() || null,
      nfc: window.SmoofNfcTools?.getHistoryState?.() || null,
      backgroundImage: window.SmoofBackgroundImageBridge?.getHistoryState?.() ||
        window.SmoofBackgroundImageBridge?.getState?.() || null,
      layerOpacity: window.SmoofLayerOpacityTools?.getHistoryState?.() || null,
      backgroundGradient: window.SmoofBackgroundGradientTools?.getHistoryState?.() || null
    };
  }

  function historySignature(snapshot) {
    if (!snapshot) return '';
    const logo = snapshot.logo || {};
    const dataUrl = String(logo.dataUrl || '');
    return JSON.stringify({
      ...snapshot,
      logo: {
        ...logo,
        dataUrl: dataUrl
          ? `${dataUrl.length}:${dataUrl.slice(0, 36)}:${dataUrl.slice(-36)}`
          : ''
      }
    });
  }

  function syncHistoryButtons() {
    if (!commandbar) return;
    const undo = commandbar.querySelector('[data-smoof-ui-command-action="undo"]');
    const redo = commandbar.querySelector('[data-smoof-ui-command-action="redo"]');
    if (undo) undo.disabled = historyPast.length === 0 || historyRestoring;
    if (redo) redo.disabled = historyFuture.length === 0 || historyRestoring;
  }

  function clearHistory() {
    clearTimeout(historyTimer);
    clearTimeout(historyBaselineTimer);
    historyBaselineTimer = 0;
    historyCurrent = null;
    historyCurrentKey = '';
    historyPast = [];
    historyFuture = [];
    syncHistoryButtons();
  }

  function commitHistorySnapshot() {
    if (historyRestoring || !personalizedDesignSelected()) return;
    const next = captureHistorySnapshot();
    if (!next) return;
    const nextKey = historySignature(next);

    if (!historyCurrent) {
      historyCurrent = next;
      historyCurrentKey = nextKey;
      syncHistoryButtons();
      return;
    }

    if (nextKey === historyCurrentKey) return;
    historyPast.push(historyCurrent);
    if (historyPast.length > HISTORY_LIMIT) historyPast.shift();
    historyCurrent = next;
    historyCurrentKey = nextKey;
    historyFuture = [];
    syncHistoryButtons();
  }

  function scheduleHistoryCapture(delay = 320) {
    if (historyRestoring) return;
    clearTimeout(historyTimer);
    historyTimer = setTimeout(commitHistorySnapshot, delay);
  }

  function setNativeChecked(input, checked) {
    const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'checked');
    if (descriptor?.set) descriptor.set.call(input, checked);
    else input.checked = checked;
  }

  function applyOptionState(id, saved) {
    const rootNode = optionRoot(id);
    if (!rootNode || !saved) return;

    if (saved.kind === 'choice') {
      const wanted = new Set(saved.values || []);
      rootNode.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => {
        const checked = wanted.has(input.value);
        if (input.checked === checked) return;
        setNativeChecked(input, checked);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      return;
    }

    const control = rootNode.querySelector([
      'select',
      'textarea',
      'input[type="color"]',
      'input[type="text"]',
      'input[type="search"]'
    ].join(',')) || rootNode.querySelector('input[type="hidden"]');
    if (control && control.value !== saved.value) setNativeValue(control, saved.value, true);
  }

  function applyHistorySnapshot(snapshot) {
    if (!snapshot) return;
    historyRestoring = true;
    clearTimeout(historyTimer);
    syncHistoryButtons();

    Object.entries(snapshot.options || {}).forEach(([id, value]) => applyOptionState(id, value));

    const applyLayouts = () => {
      if (snapshot.textLayout) window.SmoofTextTools?.applyHistoryState?.(snapshot.textLayout);
      if (snapshot.logo) window.SmoofLogoHistory?.applyState?.(snapshot.logo);
      if (snapshot.logoCopy) window.SmoofLogoCopyTools?.applyHistoryState?.(snapshot.logoCopy);
      if (snapshot.logoDuplicate) window.SmoofLogoDuplicateTools?.applyHistoryState?.(snapshot.logoDuplicate);
      if (snapshot.logoInversion) window.SmoofLogoInvertTools?.applyHistoryState?.(snapshot.logoInversion);
      if (snapshot.logoBackgrounds) window.SmoofLogoBackgroundTools?.applyHistoryState?.(snapshot.logoBackgrounds);
      if (snapshot.number) window.SmoofNumberHistory?.applyState?.(snapshot.number);
      if (snapshot.arrows) window.SmoofArrowTools?.applyHistoryState?.(snapshot.arrows);
      if (snapshot.payments) window.SmoofPaymentTools?.applyHistoryState?.(snapshot.payments);
      if (snapshot.socialPlatforms) window.SmoofSocialPlatformTools?.applyHistoryState?.(snapshot.socialPlatforms);
      if (snapshot.customTexts) window.SmoofCustomTextTools?.applyHistoryState?.(snapshot.customTexts);
      if (snapshot.customPictograms) window.SmoofCustomPictogramTools?.applyHistoryState?.(snapshot.customPictograms);
      if (snapshot.qrGeometry) window.SmoofQrGeometryTools?.applyHistoryState?.(snapshot.qrGeometry);
      if (snapshot.nfc) window.SmoofNfcTools?.applyHistoryState?.(snapshot.nfc);
      if (snapshot.backgroundImage) window.SmoofBackgroundImageBridge?.applyHistoryState?.(snapshot.backgroundImage);
      if (snapshot.layerOpacity) window.SmoofLayerOpacityTools?.applyHistoryState?.(snapshot.layerOpacity);
      if (snapshot.backgroundGradient) window.SmoofBackgroundGradientTools?.applyHistoryState?.(snapshot.backgroundGradient);
      (Array.isArray(snapshot.textVisibility) ? snapshot.textVisibility : []).forEach((visible, index) => {
        if (!window.SmoofTextVisibility) return;
        if (window.SmoofTextVisibility.isVisible(index) !== visible) {
          window.SmoofTextVisibility.toggle(index);
        }
      });
    };

    applyLayouts();
    requestAnimationFrame(() => requestAnimationFrame(applyLayouts));
    setTimeout(() => {
      applyLayouts();
      historyRestoring = false;
      syncHistoryButtons();
      if (layersOpen && layersPage === 'detail') renderLayers();
      else if (selectedId) renderContext();
    }, 220);
  }

  function undoHistory() {
    if (historyRestoring) return;
    clearTimeout(historyTimer);
    commitHistorySnapshot();
    if (!historyPast.length || !historyCurrent) return;
    historyFuture.push(historyCurrent);
    const target = historyPast.pop();
    historyCurrent = target;
    historyCurrentKey = historySignature(target);
    applyHistorySnapshot(target);
  }

  function redoHistory() {
    if (historyRestoring || !historyFuture.length || !historyCurrent) return;
    historyPast.push(historyCurrent);
    const target = historyFuture.pop();
    historyCurrent = target;
    historyCurrentKey = historySignature(target);
    applyHistorySnapshot(target);
  }

  function syncPersonalizationGate() {
    const enabled = personalizedDesignSelected();
    root.dataset.smoofUiEnabled = String(enabled);
    if (!enabled) {
      dismissTemplateCoachmark(false);
      if (historyCurrent) clearHistory();
      layersOpen = false;
      layersPage = 'list';
      selectedId = '';
      if (context) context.dataset.open = 'false';
      if (layers) layers.dataset.open = 'false';
    } else if (!historyCurrent && !historyBaselineTimer) {
      historyBaselineTimer = setTimeout(() => {
        historyBaselineTimer = 0;
        commitHistorySnapshot();
      }, 420);
    }
    return enabled;
  }

  const t = (de, en) => root.lang.toLowerCase().startsWith('en') ? en : de;
  const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, character => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[character]);
  const icon = name => {
    const common = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
    const paths = {
      editor: '<path d="m4 16-1 5 5-1L19 9l-4-4L4 16Z"></path><path d="m13.5 6.5 4 4"></path>',
      templates: '<rect x="4" y="3.5" width="16" height="17" rx="3"></rect><path d="M4 9.5h16M10.5 9.5v11"></path>',
      layers: '<path d="m12 3 9 5-9 5-9-5 9-5Z"></path><path d="m3 12 9 5 9-5"></path><path d="m3 16 9 5 9-5"></path>',
      ruler: '<path d="M3 7h18v10H3z"></path><path d="M7 7v4M11 7v2M15 7v4M19 7v2"></path>',
      reset: '<path d="M4 4v6h6"></path><path d="M5.5 16a8 8 0 1 0 .5-9l-2 3"></path>',
      undo: '<path d="M9 7 4 12l5 5"></path><path d="M5 12h8a6 6 0 0 1 6 6"></path>',
      redo: '<path d="m15 7 5 5-5 5"></path><path d="M19 12h-8a6 6 0 0 0-6 6"></path>',
      save: '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z"></path><path d="M17 21v-8H7v8M7 3v5h8"></path>',
      open: '<path d="M3 6h6l2 3h7a2 2 0 0 1 2 2v1"></path><path d="M3 6v13h16l2-7H6l-3 7Z"></path>',
      help: '<circle cx="12" cy="12" r="9"></circle><path d="M9.7 9a2.5 2.5 0 1 1 4 2c-1 .7-1.7 1.2-1.7 2.5"></path><path d="M12 17h.01"></path>',
      close: '<path d="m6 6 12 12M18 6 6 18"></path>',
      back: '<path d="m15 18-6-6 6-6"></path>',
      eye: '<path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"></path><circle cx="12" cy="12" r="2.7"></circle>',
      eyeOff: '<path d="M3 3l18 18"></path><path d="M10.6 6.1A9 9 0 0 1 12 6c6 0 9.5 6 9.5 6a15 15 0 0 1-2.1 2.8M6.2 6.2C3.8 8 2.5 12 2.5 12s3.5 6 9.5 6a9 9 0 0 0 3.2-.6"></path>',
      lock: '<rect x="5" y="10" width="14" height="10" rx="2"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path>',
      text: '<path d="M5 5h14M12 5v14M8 19h8"></path>',
      arrows: '<path d="m3 8 4 4-4 4M9 8l4 4-4 4M15 8l4 4-4 4"></path>',
      nfc: '<path d="M5.2 8.1a9.7 9.7 0 0 1 13.6 0"></path><path d="M7.9 10.9a5.8 5.8 0 0 1 8.2 0"></path><path d="M10.6 13.6a2 2 0 0 1 2.8 0"></path><circle cx="12" cy="17" r=".8" fill="currentColor" stroke="none"></circle>',
      image: '<rect x="3" y="4" width="18" height="16" rx="2"></rect><circle cx="9" cy="10" r="2"></circle><path d="m21 16-5-5L5 20"></path>',
      number: '<path d="M9 3 7 21M17 3l-2 18M4 9h16M3 15h16"></path>',
      dot: '<circle cx="12" cy="12" r="7"></circle>',
      background: '<path d="M12 3a9 9 0 1 0 0 18c1.3 0 2-1.4 1.2-2.4-.7-.9-.1-2.2 1.1-2.2H17a4 4 0 0 0 4-4C21 7.2 17 3 12 3Z"></path><circle cx="7.5" cy="10" r=".8" fill="currentColor"></circle><circle cx="11" cy="7" r=".8" fill="currentColor"></circle><circle cx="15" cy="8" r=".8" fill="currentColor"></circle>',
      qr: '<path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 14h2v6h-4v-2M14 20v-2"></path>',
      payment: '<rect x="3" y="6" width="18" height="13" rx="2"></rect><path d="M3 10h18M7 15h3"></path>',
      social: '<circle cx="7" cy="7" r="3"></circle><circle cx="17" cy="7" r="3"></circle><circle cx="12" cy="17" r="3"></circle><path d="m9.5 8.5 2 5M14.5 8.5l-2 5M10 7h4"></path>',
      add: '<path d="M12 5v14M5 12h14"></path>',
      trash: '<path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5"></path>'
    };
    return `<svg ${common}>${paths[name] || paths.text}</svg>`;
  };

  const descriptors = () => {
    const map = {
    'text-0': { symbol: 'text', title: t('Textzeile 1', 'Text line 1'), copy: t('Schrift, Schnitt, Farbe und Größe', 'Font, style, colour and size'), kind: 'text', hideable: true },
    'text-1': { symbol: 'text', title: t('Textzeile 2', 'Text line 2'), copy: t('Schrift, Schnitt, Farbe und Größe', 'Font, style, colour and size'), kind: 'text', hideable: true },
    'text-2': { symbol: 'text', title: t('Textzeile 3', 'Text line 3'), copy: t('Schrift, Schnitt, Farbe und Größe', 'Font, style, colour and size'), kind: 'text', hideable: true },
    'arrow-left': { symbol: 'arrows', title: t('Piktogramm links', 'Left pictogram'), copy: t('Motiv, Drehung, Farben und Text', 'Symbol, rotation, colours and label'), kind: 'arrow', hideable: true },
    'arrow-right': { symbol: 'arrows', title: t('Piktogramm rechts', 'Right pictogram'), copy: t('Motiv, Drehung, Farben und Text', 'Symbol, rotation, colours and label'), kind: 'arrow', hideable: true },
    logo: { symbol: 'image', title: 'Logo', copy: t('Position, Größe, Datei und Sichtbarkeit', 'Position, size, file and visibility'), kind: 'logo', hideable: true },
    'logo-copy': { symbol: 'image', title: t('Logo-1-Duplikat', 'Logo 1 duplicate'), copy: t('Verknüpftes Duplikat von Logo 1', 'Linked duplicate of logo 1'), kind: 'logo-copy', hideable: true },
    'logo-2': { symbol: 'image', title: t('Logo 2', 'Logo 2'), copy: t('Eigenständige Logodatei, Position und Größe', 'Independent logo file, position and size'), kind: 'logo-duplicate', hideable: true },
    'table-number': { symbol: 'number', title: t('Tisch-/Zimmernummer', 'Table/room number'), copy: t('Optionales Textelement', 'Optional text element'), kind: 'number', hideable: true },
    'branding-dot': { symbol: 'dot', title: t('Branding-Kreis', 'Branding circle'), copy: t('Farbe und Sichtbarkeit', 'Colour and visibility'), kind: 'brand', hideable: true },
    nfc: { symbol: 'nfc', title: 'NFC', copy: t('Symbol, Kreisfarbe und Position', 'Icon, circle colour and position'), kind: 'nfc', hideable: true },
    payments: { symbol: 'payment', title: t('Zahlungsanbieter', 'Payment providers'), copy: t('Mehrfachauswahl, Farbe und Größe', 'Multiple selection, colour and size'), kind: 'payments', hideable: true },
    'social-library': { symbol: 'social', title: t('Social Media & Plattformen', 'Social media & platforms'), copy: t('Bewertungen, Social Media und Plattformen', 'Reviews, social media and platforms'), kind: 'social-library' },
    add: { symbol: 'add', title: t('Hinzufügen', 'Add'), copy: t('Weitere Elemente ergänzen', 'Add more elements'), kind: 'add' },
    downloads: { symbol: 'save', title: t('Uploads & Downloads', 'Uploads & Downloads'), copy: t('Design- und Druckdateien', 'Design and print files'), kind: 'downloads' },
    templates: { symbol: 'templates', title: t('Vorlagen', 'Templates'), copy: t('Nach Anwendungsfall auswählen', 'Choose by use case'), kind: 'templates' },
    qr: { symbol: 'qr', title: 'QR-Code', copy: t('Sichtbarkeit, Position, Größe und Hintergrundfläche', 'Visibility, position, size and backing panel'), kind: 'qr', locked: false, hideable: true },
      background: {
        symbol: 'background',
        title: t('Hintergrund', 'Background'),
        copy: backgroundLocked
          ? t('Edelstahloberfläche ist fest vorgegeben', 'Stainless-steel surface is fixed')
          : t('Farbe, Verlauf und optionales Bild', 'Colour, gradient and optional image'),
        kind: 'background',
        locked: true
      }
    };
    (window.SmoofCustomTextTools?.getStates?.() || []).filter(state => state.enabled).forEach(state => {
      const number = Number(String(state.id || '').split('-').pop()) || 1;
      map[state.id] = {
        symbol: 'text',
        title: t(`Zusatztext ${number}`, `Additional text ${number}`),
        copy: t('Schrift, Schnitt, Farbe und Größe', 'Font, style, colour and size'),
        kind: 'custom-text',
        hideable: true
      };
    });
    (window.SmoofCustomPictogramTools?.getStates?.() || []).filter(state => state.enabled).forEach(state => {
      const number = Number(String(state.id || '').split('-').pop()) || 1;
      map[state.id] = {
        symbol: 'arrows',
        title: t(`Zusatzpiktogramm ${number}`, `Additional pictogram ${number}`),
        copy: t('Motiv, Drehung, Farbe und Größe', 'Symbol, rotation, colour and size'),
        kind: 'custom-pictogram',
        hideable: true
      };
    });
    Object.keys(window.SmoofSocialPlatformTools?.getState?.().objects || {}).forEach(id => {
      const definition = window.SmoofSocialPlatformLibrary?.get?.(id);
      if (!definition) return;
      map[`social-platform-${id}`] = {
        symbol: 'social', title: definition.label,
        copy: t('Position, Farbe und Größe', 'Position, colour and size'),
        kind: 'social-platform', hideable: true
      };
    });
    return map;
  };

  function sourceFor(id) {
    if (id === 'downloads' || id === 'templates' || id === 'add') return commandbar;
    if (id === 'social-library') return commandbar;
    if (/^social-platform-/.test(id)) {
      return document.querySelector(`[data-smoof-social-platform-frame="${id.replace(/^social-platform-/, '')}"]`);
    }
    if (/^custom-text-[1-3]$/.test(id)) {
      return document.querySelector(`[data-smoof-editor-item="${id}"]`);
    }
    if (/^custom-pictogram-[1-3]$/.test(id)) {
      return document.querySelector(`[data-smoof-custom-pictogram-frame="${id}"]`);
    }
    if (/^text-[0-2]$/.test(id)) {
      const frames = Array.from(document.querySelectorAll(`[data-smoof-text-frame="${id.split('-')[1]}"]`));
      const frame = frames.find(candidate => candidate.dataset.active === 'true') || frames.find(candidate => {
        const rect = candidate.getBoundingClientRect();
        const style = getComputedStyle(candidate);
        return style.display !== 'none' && rect.width > 2 && rect.height > 2;
      }) || frames[0];
      return frame ? frame.querySelector('[data-smoof-text-controls]') : null;
    }
    const selectors = {
      logo: '[data-smoof-logo-editor-frame]:not([data-smoof-logo-instance]) [data-smoof-logo-controls]',
      'logo-copy': '[data-smoof-logo-copy-controls]',
      'logo-2': '[data-smoof-logo-duplicate-controls]',
      'arrow-left': '[data-smoof-arrow-controls]',
      'arrow-right': '[data-smoof-arrow-controls]',
      'table-number': '[data-smoof-number-controls]',
      'branding-dot': '[data-smoof-brand-controls]',
      nfc: '[data-smoof-nfc-frame]',
      payments: '[data-smoof-payment-frame]',
      background: '[data-smoof-background-controls]',
      qr: '[data-smoof-qr-frame]'
    };
    return selectors[id] ? document.querySelector(selectors[id]) : null;
  }

  function visibleItemFor(id) {
    return Array.from(document.querySelectorAll(`[data-smoof-editor-item="${id}"]`)).find(el => {
      if (el.closest('[data-smoof-ui-context], [data-smoof-ui-layers], [data-smoof-ui-commandbar]')) return false;
      if (el.matches('[data-smoof-text-controls], [data-smoof-logo-controls], [data-smoof-arrow-controls], [data-smoof-number-controls], [data-smoof-brand-controls]')) return false;
      const rect = el.getBoundingClientRect();
      const style = getComputedStyle(el);
      return !el.hidden && style.display !== 'none' && rect.width > 2 && rect.height > 2;
    }) || null;
  }

  function visibilitySource(id) {
    const controls = sourceFor(id);
    if (!controls) return null;
    if (/^text-/.test(id)) return controls.querySelector('[data-smoof-text-control-button="visibility"]');
    if (id === 'table-number') return controls.querySelector('[data-smoof-number-control-button="visibility"]');
    return null;
  }

  function isVisible(id) {
    if (/^custom-pictogram-[1-3]$/.test(id)) {
      return window.SmoofCustomPictogramTools?.isVisible?.(id) !== false;
    }
    if (/^custom-text-[1-3]$/.test(id)) {
      return window.SmoofCustomTextTools?.isVisible?.(id) !== false;
    }
    if (id === 'logo' && window.SmoofLogoTools?.isVisible) {
      return window.SmoofLogoTools.isVisible();
    }
    if (id === 'logo-2' && window.SmoofLogoDuplicateTools?.isVisible) {
      return window.SmoofLogoDuplicateTools.isVisible();
    }
    if (id === 'logo-copy' && window.SmoofLogoCopyTools?.isVisible) {
      return window.SmoofLogoCopyTools.isVisible();
    }
    if (id === 'nfc' && window.SmoofNfcTools?.isVisible) {
      return window.SmoofNfcTools.isVisible();
    }
    if (id === 'payments' && window.SmoofPaymentTools?.isVisible) {
      return window.SmoofPaymentTools.isVisible();
    }
    if (/^social-platform-/.test(id) && window.SmoofSocialPlatformTools?.isVisible) {
      return window.SmoofSocialPlatformTools.isVisible(id);
    }
    if (/^arrow-(left|right)$/.test(id) && window.SmoofArrowTools?.isVisible) {
      return window.SmoofArrowTools.isVisible(id.split('-')[1]);
    }
    if (id === 'branding-dot') {
      if (window.SmoofBrandTools?.isVisible) {
        return window.SmoofBrandTools.isVisible();
      }
      const dot = document.querySelector('[data-smoof-brand-dot]');
      const stored = dot?.dataset.smoofBrandVisible;
      if (stored === 'true' || stored === 'false') return stored === 'true';
      return dot ? !dot.hidden : true;
    }
    if (/^text-[0-2]$/.test(id) && window.SmoofTextVisibility) {
      return window.SmoofTextVisibility.isVisible(Number(id.split('-')[1]));
    }
    if (id === 'table-number' && window.SmoofNumberVisibilityTools?.isVisible) {
      return window.SmoofNumberVisibilityTools.isVisible();
    }
    if (id === 'qr' && window.SmoofQrGeometryTools?.isVisible) {
      return window.SmoofQrGeometryTools.isVisible();
    }
    const control = visibilitySource(id);
    if (control) {
      if (control.dataset.visible) return control.dataset.visible !== 'false';
      const pressed = control.getAttribute('aria-pressed');
      if (pressed !== null) return pressed !== 'true';
    }
    if (/^text-/.test(id)) {
      const index = id.split('-')[1];
      const frame = document.querySelector(`[data-smoof-text-frame="${index}"]`);
      return !frame || frame.dataset.visible !== 'false';
    }
    if (id === 'table-number') return Boolean(visibleItemFor(id));
    return true;
  }

  function toggleVisibility(id) {
    if (/^custom-pictogram-[1-3]$/.test(id)) {
      window.SmoofCustomPictogramTools?.toggleVisibility?.(id);
      return;
    }
    if (/^custom-text-[1-3]$/.test(id)) {
      window.SmoofCustomTextTools?.toggleVisibility?.(id);
      return;
    }
    if (id === 'logo' && window.SmoofLogoTools?.toggleVisibility) {
      window.SmoofLogoTools.toggleVisibility();
      return;
    }
    if (id === 'logo-2' && window.SmoofLogoDuplicateTools?.toggleVisibility) {
      window.SmoofLogoDuplicateTools.toggleVisibility();
      return;
    }
    if (id === 'logo-copy' && window.SmoofLogoCopyTools?.toggleVisibility) {
      window.SmoofLogoCopyTools.toggleVisibility();
      return;
    }
    if (id === 'nfc' && window.SmoofNfcTools?.toggleVisibility) {
      window.SmoofNfcTools.toggleVisibility();
      return;
    }
    if (id === 'payments' && window.SmoofPaymentTools?.toggleVisibility) {
      window.SmoofPaymentTools.toggleVisibility();
      return;
    }
    if (/^social-platform-/.test(id) && window.SmoofSocialPlatformTools?.toggleVisibility) {
      window.SmoofSocialPlatformTools.toggleVisibility(id);
      return;
    }
    if (/^arrow-(left|right)$/.test(id) && window.SmoofArrowTools?.toggleVisibility) {
      window.SmoofArrowTools.toggleVisibility(id.split('-')[1]);
      return;
    }
    if (id === 'branding-dot') {
      if (window.SmoofBrandTools?.toggleVisibility) {
        window.SmoofBrandTools.toggleVisibility();
        return;
      }

      /*
       * Sicherheitsnetz fuer Themes, in denen noch der alte Branding-Block
       * aktiv ist. Der eigentliche Fix wird mit v2.18.4 ebenfalls geliefert,
       * aber das Auge darf bei einem Versions-Mix nicht erneut wirkungslos
       * bleiben.
       */
      const visible = !isVisible(id);
      document.querySelectorAll('[data-smoof-brand-dot]').forEach(dot => {
        dot.hidden = !visible;
        dot.dataset.smoofBrandVisible = String(visible);
        dot.setAttribute('aria-hidden', String(!visible));
      });
      document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        let input = form.querySelector('input[name="properties[_SMOOF Branding sichtbar]"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[_SMOOF Branding sichtbar]';
          form.appendChild(input);
        }
        input.value = visible ? 'Ja' : 'Nein';
      });
      window.SmoofDesignRenderer?.scheduleRender?.();
      window.dispatchEvent(new CustomEvent('smoof:branding-visibility-changed', {
        detail: { visible }
      }));
      return;
    }
    if (/^text-[0-2]$/.test(id) && window.SmoofTextVisibility) {
      window.SmoofTextVisibility.toggle(Number(id.split('-')[1]));
      return;
    }
    if (id === 'table-number' && window.SmoofNumberVisibilityTools?.toggleVisibility) {
      window.SmoofNumberVisibilityTools.toggleVisibility();
      return;
    }
    if (id === 'qr' && window.SmoofQrGeometryTools?.toggleVisibility) {
      window.SmoofQrGeometryTools.toggleVisibility();
      return;
    }
    const control = visibilitySource(id);
    if (control && !control.disabled) control.click();
  }

  function dispatchSelection(id, options = {}) {
    window.dispatchEvent(new CustomEvent(SELECT_EVENT, {
      detail: {
        id: String(id || ''),
        openContext: options.openContext === true
      }
    }));
  }

  function row(label, body) {
    return `<div data-smoof-ui-row><span data-smoof-ui-row-label>${label}</span><div>${body}</div></div>`;
  }

  function fontButton(family) {
    const safeFamily = escapeHtml(family);
    const actionLabel = t('Schrift auswählen', 'Choose font');
    return `<button type="button" data-smoof-ui-wide-button data-smoof-ui-font-button data-smoof-ui-action="text-font" aria-label="${actionLabel}: ${safeFamily}" title="${safeFamily}"><span>${safeFamily}</span><small aria-hidden="true">→</small></button>`;
  }

  function colorRow(label, proxy, selector) {
    const input = source ? source.querySelector(selector) : null;
    const locked = laserMonochromeActive();
    const value = locked ? '#000000' : (input?.value || '#000000');
    const disabled = locked ? ' disabled aria-disabled="true"' : '';
    return row(label, `<label data-smoof-ui-color-wrap${locked ? ' data-smoof-ui-laser-colour-locked="true"' : ''}><span data-smoof-ui-color-swatch style="background-color:${value}"></span><span data-smoof-ui-color-value>${value.toUpperCase()}</span><input data-smoof-ui-color="${proxy}" type="color" value="${value}" aria-label="${label}"${disabled}></label>`);
  }

  function colorRowValue(label, proxy, value) {
    const locked = laserMonochromeActive();
    const safe = locked
      ? '#000000'
      : (/^#[0-9a-f]{6}$/i.test(String(value)) ? value : '#000000');
    const disabled = locked ? ' disabled aria-disabled="true"' : '';
    return row(label, `<label data-smoof-ui-color-wrap${locked ? ' data-smoof-ui-laser-colour-locked="true"' : ''}><span data-smoof-ui-color-swatch style="background-color:${safe}"></span><span data-smoof-ui-color-value>${safe.toUpperCase()}</span><input data-smoof-ui-color="${proxy}" type="color" value="${safe}" aria-label="${label}"${disabled}></label>`);
  }

  function normalizeHexColor(value, allowShort = true) {
    const compact = String(value || '').trim().replace(/^#/, '');
    if (allowShort && /^[0-9a-f]{3}$/i.test(compact)) {
      return `#${compact.split('').map(character => character + character).join('')}`.toUpperCase();
    }
    return /^[0-9a-f]{6}$/i.test(compact)
      ? `#${compact}`.toUpperCase()
      : '';
  }

  function hexColorRow(label, proxy, rawValue, locked = false) {
    const effectiveLocked = locked || laserMonochromeActive();
    const value = effectiveLocked ? '#000000' : (normalizeHexColor(rawValue) || '#000000');
    const disabled = effectiveLocked ? ' disabled aria-disabled="true"' : '';
    return row(
      label,
      `<div data-smoof-ui-hex-color-editor${effectiveLocked ? ' data-smoof-ui-laser-colour-locked="true"' : ''}>` +
        `<label data-smoof-ui-color-wrap data-smoof-ui-hex-color-swatch title="${t('Farbe auswählen', 'Choose colour')}">` +
          `<span data-smoof-ui-color-swatch style="background-color:${value}"></span>` +
          `<span data-smoof-ui-color-value>${value}</span>` +
          `<input data-smoof-ui-color="${proxy}" type="color" value="${value}" aria-label="${label}"${disabled}>` +
        `</label>` +
        `<input data-smoof-ui-hex-color="${proxy}" type="text" value="${value}" maxlength="7" inputmode="text" autocomplete="off" autocapitalize="characters" spellcheck="false" aria-label="${label} ${t('als Hexcode', 'as hex code')}" aria-invalid="false"${disabled}>` +
      `</div>`
    );
  }

  function sourceHexColorRow(label, proxy, selector) {
    const input = source ? source.querySelector(selector) : null;
    return hexColorRow(label, proxy, input?.value || '#000000');
  }

  function letterSpacingRow(value) {
    const spacing = Number.isFinite(Number(value)) ? Number(value) : 0;
    return row(
      t('Laufweite', 'Letter spacing'),
      `<div data-smoof-ui-stepper>` +
        `<button type="button" data-smoof-ui-action="letter-spacing-minus" aria-label="${t('Laufweite verringern', 'Decrease letter spacing')}">−</button>` +
        `<span data-smoof-ui-letter-spacing>${Math.round(spacing * 100)}%</span>` +
        `<button type="button" data-smoof-ui-action="letter-spacing-plus" aria-label="${t('Laufweite erhöhen', 'Increase letter spacing')}">+</button>` +
      `</div>`
    );
  }

  function backgroundColorRow(label) {
    const input = source ? source.querySelector('input[type="color"]') : null;
    return hexColorRow(label, 'background-color', input?.value);
  }

  function styleRow(proxy, selector, locked = false) {
    const select = source ? source.querySelector(selector) : null;
    const options = locked
      ? '<option value="Normal" selected>Normal</option>'
      : select ? Array.from(select.options).map(option => `<option value="${option.value}"${option.selected ? ' selected' : ''}>${option.textContent}</option>`).join('') : '';
    return row(t('Schnitt', 'Style'), `<select data-smoof-ui-select="${proxy}" aria-label="${t('Schriftschnitt', 'Font style')}"${locked ? ' disabled title="' + t('Dieser Upload enthält nur den Schnitt Normal.', 'This upload contains only the Normal style.') + '"' : ''}>${options}</select>`);
  }

  function sharedFontStyleOptions(selectedValue = 'Normal', locked = false) {
    if (locked) return '<option value="Normal" selected>Normal</option>';
    const values = Array.from(window.SmoofTextTools?.styleOptions || [
      'Light',
      'Light & Kursiv',
      'Normal',
      'Kursiv',
      'Fett',
      'Fett & Kursiv'
    ]);
    const selected = window.SmoofTextTools?.normalizeStyle?.(selectedValue) || selectedValue || 'Normal';
    return values.map(value =>
      `<option value="${escapeHtml(value)}"${selected === value ? ' selected' : ''}>${escapeHtml(value)}</option>`
    ).join('');
  }

  function pictogramPreview(iconRecord, side, selected = false) {
    const library = window.SmoofPictogramLibrary;
    const previewUrl = library?.dataUrl?.(iconRecord?.id, side) || '';
    const style = previewUrl
      ? ` style="--smoof-pictogram-image:url(&quot;${escapeHtml(previewUrl)}&quot;)"`
      : '';
    return `<span data-smoof-ui-pictogram-preview data-selected="${String(selected)}" data-raster="${String(iconRecord?.raster === true)}"${style}></span>`;
  }

  function alignActivePictogramCategory(container) {
    requestAnimationFrame(() => {
      const active = container?.querySelector?.('[data-smoof-ui-pictogram-category][data-active="true"]');
      active?.scrollIntoView?.({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  }

  function rememberPictogramCategoryScroll(container, key) {
    const tabs = container?.querySelector?.('[data-smoof-ui-pictogram-tabs]');
    if (!tabs) return;
    pictogramCategoryScroll[key] = Math.max(0, Number(tabs.scrollLeft) || 0);
  }

  function restorePictogramCategoryScroll(container, key) {
    const saved = Number(pictogramCategoryScroll[key]);
    requestAnimationFrame(() => {
      const tabs = container?.querySelector?.('[data-smoof-ui-pictogram-tabs]');
      if (!tabs || !Number.isFinite(saved)) return;
      tabs.scrollLeft = Math.max(0, saved);
    });
  }

  function availablePictogramCategories(side) {
    const library = window.SmoofPictogramLibrary;
    if (!library?.icons?.length) return [];
    const state = window.SmoofArrowTools?.getState?.(side);
    const current = library.get?.(state?.symbol);
    return Object.keys(library.categories).filter(id => {
      if (id === 'custom') return Boolean(current?.custom);
      return library.icons.some(iconRecord => iconRecord.category === id);
    });
  }

  function pictogramRow(state, side) {
    const library = window.SmoofPictogramLibrary;
    if (!library?.icons?.length) return '';
    const language = root.lang.toLowerCase().startsWith('en') ? 'en' : 'de';
    const current = library.get?.(state.symbol) || library.get?.('dots') || library.icons[0];
    const currentName = current?.[language] || current?.de || t('Motiv', 'Symbol');
    const isOpen = pictogramPickerOpenFor === side;
    const category = pictogramPickerCategory[side] || current?.category || 'arrows';
    const categoryButtons = availablePictogramCategories(side).map(id => {
      const label = library.categories[id]?.[language] || id;
      return `<button type="button" data-smoof-ui-pictogram-category="${escapeHtml(id)}" data-smoof-ui-action="pictogram-category:${escapeHtml(id)}" data-active="${String(category === id)}">${escapeHtml(label)}</button>`;
    }).join('');
    const candidates = [
      ...library.icons.filter(iconRecord => iconRecord.category === category),
      ...(category === 'custom' && current?.custom ? [current] : [])
    ].filter((iconRecord, index, list) => list.findIndex(candidate => candidate.id === iconRecord.id) === index);
    const cards = candidates.map(iconRecord => {
      const title = iconRecord[language] || iconRecord.de || iconRecord.id;
      const active = iconRecord.id === state.symbol;
      return `<button type="button" data-smoof-ui-pictogram-card data-active="${String(active)}" data-smoof-ui-action="pictogram-select:${escapeHtml(iconRecord.id)}" aria-pressed="${String(active)}">${pictogramPreview(iconRecord, side, active)}<span>${escapeHtml(title)}</span></button>`;
    }).join('');
    const picker = isOpen
      ? `<div data-smoof-ui-pictogram-library><div data-smoof-ui-pictogram-tabs>${categoryButtons}</div><div data-smoof-ui-pictogram-grid>${cards}<button type="button" data-smoof-ui-pictogram-card data-smoof-ui-pictogram-upload-card data-smoof-ui-action="pictogram-upload"><span data-smoof-ui-pictogram-upload-icon>＋</span><span>${t('Eigenes SVG oder PNG', 'Custom SVG or PNG')}</span></button></div><input type="file" accept=".svg,.png,image/svg+xml,image/png" data-smoof-ui-pictogram-upload="${side}" hidden><p data-smoof-ui-pictogram-status aria-live="polite">${t('SVG bis 600 KB oder transparentes PNG bis 500 KB und 1.000 × 1.000 px.', 'SVG up to 600 KB or transparent PNG up to 500 KB and 1,000 × 1,000 px.')}</p></div>`
      : '';
    return row(t('Motiv', 'Symbol'), `<button type="button" data-smoof-ui-pictogram-current data-smoof-ui-action="pictogram-picker-toggle" aria-expanded="${String(isOpen)}">${pictogramPreview(current, side, true)}<span><strong>${escapeHtml(currentName)}</strong><small>${t('Motiv auswählen', 'Choose symbol')}</small></span><b>${isOpen ? '↑' : '→'}</b></button>${picker}`);
  }

  function customPictogramRow(state, itemId) {
    const library = window.SmoofPictogramLibrary;
    if (!library?.icons?.length) return '';
    const language = root.lang.toLowerCase().startsWith('en') ? 'en' : 'de';
    const side = state.mirrored ? 'right' : 'left';
    const current = library.get?.(state.symbol) || library.get?.('dots') || library.icons[0];
    const currentName = current?.[language] || current?.de || t('Motiv', 'Symbol');
    const isOpen = pictogramPickerOpenFor === itemId;
    const category = pictogramPickerCategory[itemId] || current?.category || 'arrows';
    const categories = Object.keys(library.categories).filter(id => {
      if (id === 'custom') return Boolean(current?.custom);
      return library.icons.some(iconRecord => iconRecord.category === id);
    });
    const categoryButtons = categories.map(id => {
      const label = library.categories[id]?.[language] || id;
      return `<button type="button" data-smoof-ui-pictogram-category="${escapeHtml(id)}" data-smoof-ui-action="custom-pictogram-category:${escapeHtml(id)}" data-active="${String(category === id)}">${escapeHtml(label)}</button>`;
    }).join('');
    const candidates = [
      ...library.icons.filter(iconRecord => iconRecord.category === category),
      ...(category === 'custom' && current?.custom ? [current] : [])
    ].filter((iconRecord, index, list) => list.findIndex(candidate => candidate.id === iconRecord.id) === index);
    const cards = candidates.map(iconRecord => {
      const title = iconRecord[language] || iconRecord.de || iconRecord.id;
      const active = iconRecord.id === state.symbol;
      return `<button type="button" data-smoof-ui-pictogram-card data-active="${String(active)}" data-smoof-ui-action="custom-pictogram-select:${escapeHtml(iconRecord.id)}" aria-pressed="${String(active)}">${pictogramPreview(iconRecord, side, active)}<span>${escapeHtml(title)}</span></button>`;
    }).join('');
    const picker = isOpen
      ? `<div data-smoof-ui-pictogram-library><div data-smoof-ui-pictogram-tabs>${categoryButtons}</div><div data-smoof-ui-pictogram-grid>${cards}<button type="button" data-smoof-ui-pictogram-card data-smoof-ui-pictogram-upload-card data-smoof-ui-action="custom-pictogram-upload"><span data-smoof-ui-pictogram-upload-icon>＋</span><span>${t('Eigenes SVG oder PNG', 'Custom SVG or PNG')}</span></button></div><input type="file" accept=".svg,.png,image/svg+xml,image/png" data-smoof-ui-custom-pictogram-upload="${itemId}" hidden><p data-smoof-ui-pictogram-status aria-live="polite">${t('SVG bis 600 KB oder transparentes PNG bis 500 KB und 1.000 × 1.000 px.', 'SVG up to 600 KB or transparent PNG up to 500 KB and 1,000 × 1,000 px.')}</p></div>`
      : '';
    return row(t('Motiv', 'Symbol'), `<button type="button" data-smoof-ui-pictogram-current data-smoof-ui-action="custom-pictogram-picker-toggle" aria-expanded="${String(isOpen)}">${pictogramPreview(current, side, true)}<span><strong>${escapeHtml(currentName)}</strong><small>${t('Motiv auswählen', 'Choose symbol')}</small></span><b>${isOpen ? '↑' : '→'}</b></button>${picker}`);
  }

  function scalePropertyName(itemId) {
    if (/^text-[0-2]$/.test(itemId)) {
      return `properties[_SMOOF Text ${Number(itemId.split('-')[1]) + 1} Skalierung]`;
    }
    if (itemId === 'logo') return 'properties[_SMOOF Logo Skalierung]';
    if (itemId === 'logo-copy') return 'properties[_SMOOF Logo 1 Duplikat Skalierung]';
    if (itemId === 'logo-2') return 'properties[_SMOOF Logo 2 Skalierung]';
    if (itemId === 'arrow-left') return 'properties[_SMOOF Piktogramm links Skalierung]';
    if (itemId === 'arrow-right') return 'properties[_SMOOF Piktogramm rechts Skalierung]';
    if (itemId === 'table-number') return 'properties[_SMOOF Nummer Skalierung]';
    if (itemId === 'qr') return 'properties[_SMOOF QR Skalierung]';
    return '';
  }

  function currentScalePercent(itemId = selectedId) {
    if (/^custom-pictogram-[1-3]$/.test(itemId)) {
      const scale = Number(window.SmoofCustomPictogramTools?.getState?.(itemId)?.scale);
      return Math.round((Number.isFinite(scale) ? scale : 1) * 100);
    }
    if (/^custom-text-[1-3]$/.test(itemId)) {
      const scale = Number(window.SmoofCustomTextTools?.getState?.(itemId)?.scale);
      return Math.round((Number.isFinite(scale) ? scale : 1) * 100);
    }
    const propertyName = scalePropertyName(itemId);
    const productForm = Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
      .find(form => form.querySelector('button[type="submit"]'));
    const values = propertyName
      ? Array.from((productForm || document).querySelectorAll('input')).filter(input => input.name === propertyName)
      : [];
    const value = values.map(input => Number.parseFloat(input.value)).find(Number.isFinite);
    return Math.round((Number.isFinite(value) ? value : 1) * 100);
  }

  function syncScaleReadout(panel, itemId) {
    const output = panel?.querySelector('[data-smoof-ui-scale-value]');
    if (output) output.textContent = `${currentScalePercent(itemId)}%`;
  }

  function sizeRow(kind) {
    return row(t('Größe', 'Size'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="${kind}-minus" aria-label="${t('Verkleinern', 'Decrease')}">−</button><span data-smoof-ui-scale-value>${currentScalePercent()}%</span><button type="button" data-smoof-ui-action="${kind}-plus" aria-label="${t('Vergrößern', 'Increase')}">+</button></div>`);
  }

  function opacityRow(itemId = selectedId) {
    if (/^custom-pictogram-[1-3]$/.test(itemId)) {
      const opacity = Number(window.SmoofCustomPictogramTools?.getState?.(itemId)?.opacity);
      return row(t('Deckkraft', 'Opacity'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="opacity-minus" aria-label="${t('Deckkraft reduzieren', 'Decrease opacity')}">−</button><span data-smoof-ui-opacity-value>${Math.round((Number.isFinite(opacity) ? opacity : 1) * 100)}%</span><button type="button" data-smoof-ui-action="opacity-plus" aria-label="${t('Deckkraft erhöhen', 'Increase opacity')}">+</button></div>`);
    }
    if (/^custom-text-[1-3]$/.test(itemId)) {
      const opacity = Number(window.SmoofCustomTextTools?.getState?.(itemId)?.opacity);
      return row(t('Deckkraft', 'Opacity'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="opacity-minus" aria-label="${t('Deckkraft reduzieren', 'Decrease opacity')}">−</button><span data-smoof-ui-opacity-value>${Math.round((Number.isFinite(opacity) ? opacity : 1) * 100)}%</span><button type="button" data-smoof-ui-action="opacity-plus" aria-label="${t('Deckkraft erhöhen', 'Increase opacity')}">+</button></div>`);
    }
    if (!window.SmoofLayerOpacityTools?.supports?.(itemId)) return '';
    const opacity = window.SmoofLayerOpacityTools.get(itemId);
    return row(t('Deckkraft', 'Opacity'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="opacity-minus" aria-label="${t('Deckkraft reduzieren', 'Decrease opacity')}">−</button><span data-smoof-ui-opacity-value>${Math.round(opacity * 100)}%</span><button type="button" data-smoof-ui-action="opacity-plus" aria-label="${t('Deckkraft erhöhen', 'Increase opacity')}">+</button></div>`);
  }

  function logoBackgroundRows(itemId = selectedId) {
    const background = window.SmoofLogoBackgroundTools?.get?.(itemId);
    if (!background) return '';
    const shapeOptions = [
      ['rectangle', t('Rechteckig', 'Rectangular')],
      ['rounded', t('Abgerundete Ecken', 'Rounded corners')],
      ['circle', t('Rund', 'Round')]
    ].map(([value, label]) => `<option value="${value}"${background.shape === value ? ' selected' : ''}>${label}</option>`).join('');
    return row(t('Fläche', 'Fill'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="logo-background-toggle"><span>${background.enabled ? t('Aktiv', 'Active') : t('Aus', 'Off')}</span><small>${background.enabled ? t('Deaktivieren', 'Disable') : t('Aktivieren', 'Enable')} →</small></button>`) +
      (background.enabled
        ? row(t('Form', 'Shape'), `<select data-smoof-ui-select="logo-background-shape" aria-label="${t('Hintergrundform', 'Background shape')}">${shapeOptions}</select>`) +
          colorRowValue(t('Flächenfarbe', 'Background colour'), 'logo-background-color', background.color) +
          row(t('Innenabstand', 'Padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="logo-background-padding-minus">−</button><span data-smoof-ui-logo-padding-value>${Math.round(background.padding * 100)}%</span><button type="button" data-smoof-ui-action="logo-background-padding-plus">+</button></div>`)
        : '');
  }

  function paymentProviderGrid(state) {
    const providers = window.SmoofPaymentProviderLibrary?.providers || [];
    if (!providers.length) return '';
    const selected = new Set(state.selected || []);
    return `<div data-smoof-ui-payment-grid>${providers.map(provider =>
      `<label data-smoof-ui-payment-option><input type="checkbox" data-smoof-ui-payment-provider="${provider.id}"${selected.has(provider.id) ? ' checked' : ''}><span>${provider.label}</span></label>`
    ).join('')}</div>`;
  }

  function socialPlatformGrid() {
    const items = window.SmoofSocialPlatformLibrary?.items || [];
    const active = window.SmoofSocialPlatformTools?.getState?.().objects || {};
    const categories = [
      ['reviews', t('Bewertungen', 'Reviews')],
      ['social', t('Social Media', 'Social media')],
      ['platforms', t('Plattformen', 'Platforms')]
    ];
    return categories.map(([category, label]) => {
      const choices = items.filter(item => item.category === category).map(item =>
        `<label data-smoof-ui-social-option><input type="checkbox" data-smoof-ui-social-platform="${item.id}"${active[item.id] ? ' checked' : ''}><span>${escapeHtml(item.label)}</span></label>`
      ).join('');
      return `<section data-smoof-ui-social-category><strong>${label}</strong><div data-smoof-ui-social-grid>${choices}</div></section>`;
    }).join('');
  }

  function resetButton(kind) {
    return `<div data-smoof-ui-actions data-single="true"><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="${kind}-reset">${icon('reset')} ${t('Position und Größe zurücksetzen', 'Reset position and size')}</button></div>`;
  }

  function detailBody(descriptor) {
    if (!descriptor) return '';
    if (descriptor.kind === 'add') {
      const secondLogo = window.SmoofLogoDuplicateTools?.getState?.() || { hasLogo: false };
      const payments = window.SmoofPaymentTools?.getState?.() || { selected: [] };
      const customTextCount = Number(window.SmoofCustomTextTools?.count?.()) || 0;
      const customPictogramCount = Number(window.SmoofCustomPictogramTools?.count?.()) || 0;
      const items = [
        {
          id: 'logo-2',
          symbol: 'image',
          title: t('Zweites Logo', 'Second logo'),
          copy: t('Eine eigenständige Logodatei hinzufügen', 'Add an independent logo file'),
          available: Boolean(window.SmoofLogoDuplicateTools && !secondLogo.hasLogo)
        },
        {
          id: 'payments',
          symbol: 'payment',
          title: t('Zahlungsanbieter', 'Payment providers'),
          copy: t('Logos auswählen und gestalten', 'Choose and style provider logos'),
          available: Boolean(window.SmoofPaymentTools && !(Array.isArray(payments.selected) && payments.selected.length))
        },
        {
          id: 'social-platforms',
          symbol: 'social',
          title: t('Social Media & Plattformen', 'Social media & platforms'),
          copy: t('Bewertungen, Netzwerke und Kontaktwege', 'Reviews, networks and contact channels'),
          available: Boolean(window.SmoofSocialPlatformTools)
        },
        {
          id: 'custom-text',
          symbol: 'text',
          title: t('Text hinzufügen', 'Add text'),
          copy: t('Bis zu drei zusätzliche Textbereiche', 'Up to three additional text areas'),
          available: Boolean(window.SmoofCustomTextTools && customTextCount < 3)
        },
        {
          id: 'custom-pictogram',
          symbol: 'arrows',
          title: t('Piktogramm hinzufügen', 'Add pictogram'),
          copy: t('Bis zu drei frei platzierbare Piktogramme', 'Up to three freely placeable pictograms'),
          available: Boolean(window.SmoofCustomPictogramTools && customPictogramCount < 3)
        }
      ].filter(item => item.available);
      if (!items.length) {
        return `<div data-smoof-ui-locked-note>${t('Zurzeit sind keine zusätzlichen Elemente verfügbar.', 'No additional elements are currently available.')}</div>`;
      }
      return `<div data-smoof-ui-add-list>${items.map(item => `<button type="button" data-smoof-ui-add-item data-smoof-ui-action="add-open:${item.id}"${item.disabled ? ' disabled aria-disabled="true"' : ''}><span data-smoof-ui-add-symbol>${icon(item.symbol)}</span><span data-smoof-ui-add-copy><strong>${escapeHtml(item.title)}</strong><small>${escapeHtml(item.copy)}</small></span><span data-smoof-ui-add-arrow>→</span></button>`).join('')}</div>`;
    }
    if (descriptor.kind === 'templates') {
      const library = window.SmoofTemplateLibrary;
      const language = root.lang.toLowerCase().startsWith('en') ? 'en' : 'de';
      const categories = library?.categories || [];
      const available = library?.list?.(templateCategory) || [];
      const categoryButtons = [
        { id: '', de: 'Alle', en: 'All' },
        ...categories
      ].map(category => `<button type="button" data-smoof-ui-template-category="${escapeHtml(category.id)}" data-smoof-ui-action="template-category:${escapeHtml(category.id)}" data-active="${String(templateCategory === category.id)}">${escapeHtml(category[language] || category.de || category.id)}</button>`).join('');
      const cards = available.map(template => {
        const title = typeof template.title === 'object' ? template.title[language] || template.title.de : template.title;
        const description = typeof template.description === 'object' ? template.description[language] || template.description.de : template.description;
        const preview = template.preview
          ? `<img src="${escapeHtml(template.preview)}" alt="" loading="lazy">`
          : `<span data-smoof-ui-template-placeholder>${icon('templates')}</span>`;
        return `<article data-smoof-ui-template-card>${preview}<div><strong>${escapeHtml(title)}</strong>${description ? `<small>${escapeHtml(description)}</small>` : ''}<button type="button" data-smoof-ui-action="template-apply:${escapeHtml(template.id)}">${t('Vorlage verwenden', 'Use template')}</button></div></article>`;
      }).join('');
      return `<div data-smoof-ui-template-categories>${categoryButtons}</div>${cards ? `<div data-smoof-ui-template-grid>${cards}</div>` : `<div data-smoof-ui-template-empty>${icon('templates')}<strong>${t('Vorlagen werden vorbereitet', 'Templates are being prepared')}</strong><span>${t('Die ersten SMOOF-Designs erscheinen hier, sobald sie hinterlegt sind.', 'The first SMOOF designs will appear here as soon as they are added.')}</span></div>`}`;
    }
    if (descriptor.kind === 'social-library') {
      return socialPlatformGrid() +
        `<div data-smoof-ui-locked-note>${t('Jedes Logo wird unabhängig positioniert und eingefärbt.', 'Each logo is positioned and coloured independently.')}</div>`;
    }
    if (descriptor.kind === 'social-platform') {
      const object = window.SmoofSocialPlatformTools?.getObject?.(selectedId);
      if (!object) return '';
      return colorRowValue(t('Farbe', 'Colour'), 'social-platform-color', object.color) +
        row(t('Größe', 'Size'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="social-platform-size-minus">−</button><span data-smoof-ui-social-scale>${Math.round(object.scale * 100)}%</span><button type="button" data-smoof-ui-action="social-platform-size-plus">+</button></div>`) +
        row(t('Deckkraft', 'Opacity'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="social-platform-opacity-minus">−</button><span data-smoof-ui-social-opacity>${Math.round(object.opacity * 100)}%</span><button type="button" data-smoof-ui-action="social-platform-opacity-plus">+</button></div>`) +
        resetButton('social-platform') +
        `<div data-smoof-ui-actions data-single="true"><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="social-platform-delete">${icon('trash')} ${t('Logo entfernen', 'Remove logo')}</button></div>`;
    }
    if (descriptor.kind === 'downloads') {
      return row(t('Öffnen', 'Open'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="open-design"><span>${t('Design-Datei öffnen', 'Open design file')}</span><small>.smoofdesign →</small></button>`) +
        row(t('Design', 'Design'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="download-design"><span>${t('Design-Datei herunterladen', 'Download design file')}</span><small>.smoofdesign ↓</small></button>`) +
        row(t('Mockup', 'Mockup'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="download-mockup"><span>${t('Mockup herunterladen', 'Download mockup')}</span><small>PNG ↓</small></button>`) +
        row(t('Freigabe', 'Approval'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="download-proof"><span>${t('Proof-PDF herunterladen', 'Download proof PDF')}</span><small>PDF ↓</small></button>`) +
        row(t('Produktion', 'Production'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="download-production"><span>${t('Produktions-PDF herunterladen', 'Download production PDF')}</span><small>PDF ↓</small></button>`);
    }
    if (descriptor.kind === 'qr') {
      const qr = window.SmoofQrGeometryTools?.getState?.() || { scale: 1 };
      const diameter = Number(window.SmoofProductVariant?.get?.()?.diameterMm) || 80;
      const sizeMm = Number(window.SmoofQrGeometryTools?.sizeMm?.(diameter)) || (29 * Number(qr.scale || 1));
      const unsafe = sizeMm < 18;
      const backingLocked = window.SmoofQrGeometryTools?.isBackingLocked?.() === true;
      const codeColorLocked = window.SmoofQrGeometryTools?.isCodeColorLocked?.() === true;
      const qrVisible = qr.visible !== false;
      const backingConfigured = !backingLocked && qr.backingVisible !== false;
      const backingVisible = qrVisible && backingConfigured;
      const backingDisabled = backingLocked || !qrVisible;
      return row('QR-Code', `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="qr-visibility-toggle"><span>${qrVisible ? t('Sichtbar', 'Visible') : t('Ausgeblendet', 'Hidden')}</span><small>${qrVisible ? t('Ausblenden', 'Hide') : t('Einblenden', 'Show')} →</small></button>`) +
        hexColorRow(t('QR-Code-Farbe', 'QR code colour'), 'qr-code-color', codeColorLocked ? '#000000' : (qr.codeColor || '#000000'), codeColorLocked) +
        row(t('Hintergrundfläche', 'Backing panel'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="qr-backing-toggle"${backingDisabled ? ' disabled' : ''}><span>${backingVisible ? t('Sichtbar', 'Visible') : t('Ausgeblendet', 'Hidden')}</span><small>${backingLocked ? t('Bei DOT ME fest transparent', 'Locked transparent for DOT ME') : !qrVisible ? t('Mit QR-Code ausgeblendet', 'Hidden with QR code') : backingConfigured ? t('Ausblenden', 'Hide') : t('Einblenden', 'Show')} →</small></button>`) +
        (backingVisible ? hexColorRow(t('Flächenfarbe', 'Panel colour'), 'qr-backing-color', qr.backingColor || '#FFFFFF') : '') +
        `<div data-smoof-ui-locked-note data-smoof-ui-qr-contrast-note><strong>${t('Hinweis zur Scanbarkeit', 'Scanning guidance')}</strong><br>${t('Ein zu geringer Kontrast zwischen QR-Code und Hintergrund kann die Scanbarkeit auf einigen Geräten beeinträchtigen. Für die bestmögliche Scanbarkeit wird ein hoher Kontrast empfohlen, z. B. ein schwarzer QR-Code auf weißem Hintergrund.', 'Low contrast between the QR code and its background may affect scanning on some devices. For the best scan reliability, use high contrast, such as a black QR code on a white background.')}</div>` +
        row(t('Größe', 'Size'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="qr-scale-minus" aria-label="${t('Verkleinern', 'Decrease')}">−</button><span data-smoof-ui-qr-scale>${Math.round(Number(qr.scale || 1) * 100)}%</span><button type="button" data-smoof-ui-action="qr-scale-plus" aria-label="${t('Vergrößern', 'Increase')}">+</button></div>`) +
        `<div data-smoof-ui-locked-note${unsafe ? ' data-smoof-ui-warning="true"' : ''}><strong>${sizeMm.toFixed(1).replace('.', ',')} mm</strong>${unsafe
          ? t(' Sehr kleine QR-Codes können je nach Druck und Endgerät schlechter scanbar sein.', ' Very small QR codes may be harder to scan depending on print quality and device.')
          : t(' Wird der QR-Code ausgeblendet, verschwindet auch seine Fläche. Die Fläche kann separat ausgeblendet werden, ohne den QR-Code zu verbergen.', ' Hiding the QR code also hides its panel. The panel can be hidden separately without hiding the QR code.')}${codeColorLocked
            ? t(' Lasergravur gibt den QR-Code technisch bedingt immer schwarz aus.', ' Laser engraving always outputs the QR code in black.')
            : ''}</div>` +
        resetButton('qr');
    }
    if (!source) return `<div data-smoof-ui-locked-note>${t('Die Einstellungen dieses Elements sind momentan nicht verfügbar.', 'This element’s settings are currently unavailable.')}</div>`;
    if (descriptor.kind === 'custom-text') {
      const state = window.SmoofCustomTextTools?.getState?.(selectedId);
      if (!state) return '';
      const customFont = customFontSelected(selectedId);
      const styles = sharedFontStyleOptions(state.fontStyle, customFont);
      return row(t('Schrift', 'Font'), fontButton(fontForItem(selectedId))) +
        row(t('Schnitt', 'Style'), `<select data-smoof-ui-select="custom-text-style" aria-label="${t('Schriftschnitt', 'Font style')}"${customFont ? ' disabled' : ''}>${styles}</select>`) +
        hexColorRow(t('Farbe', 'Colour'), 'custom-text-color', state.color) +
        sizeRow('custom-text') +
        letterSpacingRow(state.letterSpacing) +
        row(t('Pillenrahmen', 'Pill outline'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="pill-toggle"><span>${state.pillVisible ? t('Aktiv', 'Active') : t('Aus', 'Off')}</span><small>${state.pillVisible ? t('Deaktivieren', 'Disable') : t('Aktivieren', 'Enable')} →</small></button>`) +
        (state.pillVisible ? hexColorRow(t('Konturfarbe', 'Outline colour'), 'pill-stroke-color', state.pillStrokeColor) +
          hexColorRow(t('Füllfarbe', 'Fill colour'), 'pill-fill-color', state.pillFillColor) +
          row(t('Füllung', 'Fill'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="pill-fill-toggle"><span>${state.pillFillVisible ? t('Farbig', 'Coloured') : t('Transparent', 'Transparent')}</span><small>${state.pillFillVisible ? t('Transparent schalten', 'Make transparent') : t('Farbe verwenden', 'Use colour')} →</small></button>`) +
          row(t('Konturstärke', 'Outline width'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-stroke-minus">−</button><span>${Math.round(state.pillStrokeWidth * 100)}%</span><button type="button" data-smoof-ui-action="pill-stroke-plus">+</button></div>`) +
          row(t('Padding horizontal', 'Horizontal padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-x-minus">−</button><span>${Math.round(state.pillPaddingX * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-x-plus">+</button></div>`) +
          row(t('Padding vertikal', 'Vertical padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-y-minus">−</button><span>${Math.round(state.pillPaddingY * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-y-plus">+</button></div>`) : '') +
        opacityRow() +
        `<div data-smoof-ui-actions><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="custom-text-reset">${icon('reset')} ${t('Zurücksetzen', 'Reset')}</button><button type="button" data-smoof-ui-icon-button data-smoof-ui-danger data-smoof-ui-action="custom-text-delete">${icon('trash')} ${t('Text entfernen', 'Remove text')}</button></div>`;
    }
    if (descriptor.kind === 'custom-pictogram') {
      const state = window.SmoofCustomPictogramTools?.getState?.(selectedId);
      if (!state) return '';
      const iconRecord = window.SmoofPictogramLibrary?.get?.(state.symbol);
      const isRaster = iconRecord?.raster === true;
      return customPictogramRow(state, selectedId) +
        (isRaster ? row(t('Darstellung', 'Appearance'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="custom-pictogram-color-mode"><span>${state.colorize ? t('Einfarbig', 'Single colour') : t('Originalfarben', 'Original colours')}</span><small>${state.colorize ? t('Original verwenden', 'Use original') : t('Einfarbig färben', 'Use single colour')} →</small></button>`) : '') +
        (!isRaster || state.colorize ? colorRowValue(t('Farbe', 'Colour'), 'custom-pictogram-color', state.color) : '') +
        row(t('Drehung', 'Rotation'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="custom-pictogram-rotation-minus">−</button><span data-smoof-ui-custom-pictogram-rotation>${Math.round(state.rotation)}°</span><button type="button" data-smoof-ui-action="custom-pictogram-rotation-plus">+</button></div>`) +
        sizeRow('custom-pictogram') +
        row(t('Spiegelung', 'Mirroring'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="custom-pictogram-mirror"><span>${state.mirrored ? t('Gespiegelt', 'Mirrored') : t('Original', 'Original')}</span><small>${t('Horizontal spiegeln', 'Mirror horizontally')} →</small></button>`) +
        opacityRow() +
        `<div data-smoof-ui-actions><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="custom-pictogram-reset">${icon('reset')} ${t('Zurücksetzen', 'Reset')}</button><button type="button" data-smoof-ui-icon-button data-smoof-ui-danger data-smoof-ui-action="custom-pictogram-delete">${icon('trash')} ${t('Piktogramm entfernen', 'Remove pictogram')}</button></div>`;
    }
    if (descriptor.kind === 'text') {
      const index = selectedId.split('-')[1];
      const currentFont = fontForItem(selectedId);
      const customFont = customFontSelected(selectedId);
      const pill = window.SmoofTextTools?.getPillState?.(Number(index)) || { pillVisible: false, pillFillVisible: false, pillStrokeColor: '#000000', pillFillColor: '#ffffff', pillStrokeWidth: 0.05, pillPaddingX: 0.45, pillPaddingY: 0.22 };
      return row(t('Schrift', 'Font'), fontButton(currentFont)) +
        styleRow('text-style', `[data-smoof-text-style-select="${index}"]`, customFont) +
        sourceHexColorRow(t('Farbe', 'Colour'), 'text-color', `[data-smoof-text-color-input="${index}"]`) +
        sizeRow('text') +
        letterSpacingRow(pill.letterSpacing) +
        row(t('Pillenrahmen', 'Pill outline'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="pill-toggle"><span>${pill.pillVisible ? t('Aktiv', 'Active') : t('Aus', 'Off')}</span><small>${pill.pillVisible ? t('Deaktivieren', 'Disable') : t('Aktivieren', 'Enable')} →</small></button>`) +
        (pill.pillVisible ? hexColorRow(t('Konturfarbe', 'Outline colour'), 'pill-stroke-color', pill.pillStrokeColor) +
          hexColorRow(t('Füllfarbe', 'Fill colour'), 'pill-fill-color', pill.pillFillColor) +
          row(t('Füllung', 'Fill'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="pill-fill-toggle"><span>${pill.pillFillVisible ? t('Farbig', 'Coloured') : t('Transparent', 'Transparent')}</span><small>${pill.pillFillVisible ? t('Transparent schalten', 'Make transparent') : t('Farbe verwenden', 'Use colour')} →</small></button>`) +
          row(t('Konturstärke', 'Outline width'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-stroke-minus">−</button><span>${Math.round(pill.pillStrokeWidth * 100)}%</span><button type="button" data-smoof-ui-action="pill-stroke-plus">+</button></div>`) +
          row(t('Padding horizontal', 'Horizontal padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-x-minus">−</button><span>${Math.round(pill.pillPaddingX * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-x-plus">+</button></div>`) +
          row(t('Padding vertikal', 'Vertical padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-y-minus">−</button><span>${Math.round(pill.pillPaddingY * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-y-plus">+</button></div>`) : '') +
        opacityRow() +
        resetButton('text');
    }
    if (descriptor.kind === 'logo') {
      const logo = window.SmoofLogoTools?.getState?.() || { hasLogo: false, fileName: '' };
      const logoCopy = window.SmoofLogoCopyTools?.getState?.() || { enabled: false };
      const logoCopyReady = Boolean(window.SmoofLogoCopyTools);
      const inverted = window.SmoofLogoInvertTools?.get?.('logo') === true;
      return (laserVectorLogoRequired()
          ? `<div data-smoof-ui-locked-note><strong>${t('SVG erforderlich', 'SVG required')}</strong><br>${t('Für die Lasergravur können ausschließlich Vektorlogos im SVG-Format hochgeladen werden.', 'Laser engraving only accepts vector logos in SVG format.')}</div>`
          : '') + sizeRow('logo') +
        (logo.hasLogo ? row(t('Darstellung', 'Appearance'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="logo-invert"><span>${inverted ? t('Farben invertiert', 'Colours inverted') : t('Originalfarben', 'Original colours')}</span><small>${inverted ? t('Original verwenden', 'Use original') : t('Invertieren', 'Invert')} →</small></button>`) : '') +
        (logo.hasLogo ? logoBackgroundRows('logo') : '') +
        row(t('Duplikat', 'Duplicate'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="add-open:logo-copy"${logo.hasLogo && logoCopyReady ? '' : ' disabled aria-disabled="true"'}><span>${logoCopy.enabled ? t('Duplikat bearbeiten', 'Edit duplicate') : t('Duplizieren', 'Duplicate')}</span><small>${logoCopy.enabled ? t('Öffnen', 'Open') : !logoCopyReady ? t('Lädt …', 'Loading …') : logo.hasLogo ? '' : t('Logo hochladen', 'Upload logo')} →</small></button>`) +
        opacityRow() +
        `<div data-smoof-ui-actions><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="logo-reset">${icon('reset')} ${t('Zurücksetzen', 'Reset')}</button><button type="button" data-smoof-ui-icon-button${logo.hasLogo ? ' data-smoof-ui-danger' : ''} data-smoof-ui-action="logo-file">${icon(logo.hasLogo ? 'trash' : 'image')} ${logo.hasLogo ? t('Entfernen', 'Remove') : t('Upload', 'Upload')}</button></div>`;
    }
    if (descriptor.kind === 'logo-copy') {
      const logoCopy = window.SmoofLogoCopyTools?.getState?.() || { enabled: false, hasLogo: false };
      const inverted = window.SmoofLogoInvertTools?.get?.('logo-copy') === true;
      return sizeRow('logo-copy') +
        (logoCopy.hasLogo ? row(t('Darstellung', 'Appearance'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="logo-copy-invert"><span>${inverted ? t('Farben invertiert', 'Colours inverted') : t('Originalfarben', 'Original colours')}</span><small>${inverted ? t('Original verwenden', 'Use original') : t('Invertieren', 'Invert')} →</small></button>`) : '') +
        logoBackgroundRows('logo-copy') +
        opacityRow() +
        `<div data-smoof-ui-actions><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="logo-copy-reset">${icon('reset')} ${t('Zurücksetzen', 'Reset')}</button><button type="button" data-smoof-ui-icon-button data-smoof-ui-danger data-smoof-ui-action="logo-copy-toggle">${icon('trash')} ${t('Duplikat entfernen', 'Remove duplicate')}</button></div>`;
    }
    if (descriptor.kind === 'logo-duplicate') {
      const secondLogo = window.SmoofLogoDuplicateTools?.getState?.() || { hasLogo: false, fileName: '' };
      const inverted = window.SmoofLogoInvertTools?.get?.('logo-2') === true;
      return (laserVectorLogoRequired()
          ? `<div data-smoof-ui-locked-note><strong>${t('SVG erforderlich', 'SVG required')}</strong><br>${t('Für die Lasergravur können ausschließlich Vektorlogos im SVG-Format hochgeladen werden.', 'Laser engraving only accepts vector logos in SVG format.')}</div>`
          : '') + sizeRow('logo-2') +
        (secondLogo.hasLogo ? row(t('Darstellung', 'Appearance'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="logo-2-invert"><span>${inverted ? t('Farben invertiert', 'Colours inverted') : t('Originalfarben', 'Original colours')}</span><small>${inverted ? t('Original verwenden', 'Use original') : t('Invertieren', 'Invert')} →</small></button>`) : '') +
        (secondLogo.hasLogo ? logoBackgroundRows('logo-2') : '') +
        opacityRow() + `<div data-smoof-ui-actions><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="logo-2-reset">${icon('reset')} ${t('Zurücksetzen', 'Reset')}</button><button type="button" data-smoof-ui-icon-button${secondLogo.hasLogo ? ' data-smoof-ui-danger' : ''} data-smoof-ui-action="logo-2-file">${icon(secondLogo.hasLogo ? 'trash' : 'image')} ${secondLogo.hasLogo ? t('Entfernen', 'Remove') : t('Upload', 'Upload')}</button></div>`;
    }
    if (descriptor.kind === 'arrow') {
      const side = selectedId.split('-')[1];
      const state = window.SmoofArrowTools?.getState?.(side) || { rotation: 0, count: 4, symbol: 'dots', labelVisible: true, arrowColor: '#000000', labelColor: '#000000' };
      const isOriginalArrow = state.symbol === 'dots';
      const iconRecord = window.SmoofPictogramLibrary?.get?.(state.symbol);
      const isRasterPictogram = iconRecord?.raster === true;
      return pictogramRow(state, side) +
        (isRasterPictogram ? row(t('Darstellung', 'Appearance'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="pictogram-color-mode"><span>${state.colorize ? t('Einfarbig', 'Single colour') : t('Originalfarben', 'Original colours')}</span><small>${state.colorize ? t('Original verwenden', 'Use original') : t('Einfarbig färben', 'Use single colour')} →</small></button>`) : '') +
        (!isRasterPictogram || state.colorize ? colorRowValue(t('Piktogramm', 'Pictogram'), 'arrow-color', state.arrowColor) : '') +
        (isOriginalArrow ? colorRowValue(t('TAP/SCAN', 'TAP/SCAN'), 'arrow-label-color', state.labelColor) : '') +
        row(t('Drehung', 'Rotation'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="arrow-rotation-minus" aria-label="${t('Nach links drehen', 'Rotate left')}">−</button><span data-smoof-ui-arrow-rotation>${Math.round(state.rotation)}°</span><button type="button" data-smoof-ui-action="arrow-rotation-plus" aria-label="${t('Nach rechts drehen', 'Rotate right')}">+</button></div>`) +
        sizeRow('arrow-scale') +
        (isOriginalArrow ? row(t('Pfeilanzahl', 'Arrow count'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="arrow-count-minus" aria-label="${t('Weniger Pfeile', 'Fewer arrows')}">−</button><span data-smoof-ui-arrow-count>${state.count}</span><button type="button" data-smoof-ui-action="arrow-count-plus" aria-label="${t('Mehr Pfeile', 'More arrows')}">+</button></div>`) : '') +
        (isOriginalArrow ? row(t('TAP/SCAN', 'TAP/SCAN'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="arrow-label"><span>${state.labelVisible ? t('Text sichtbar', 'Label visible') : t('Text ausgeblendet', 'Label hidden')}</span><small>${state.labelVisible ? t('Ausblenden', 'Hide') : t('Einblenden', 'Show')} →</small></button>`) : '') +
        opacityRow() +
        resetButton('arrows');
    }
    if (descriptor.kind === 'number') {
      const currentFont = fontForItem('table-number');
      const numberState = window.SmoofNumberHistory?.getState?.() || { letterSpacing: 0 };
      return row(t('Schrift', 'Font'), fontButton(currentFont)) +
        styleRow('number-style', '[data-smoof-number-style-select]', customFontSelected('table-number')) +
        sourceHexColorRow(t('Farbe', 'Colour'), 'number-color', '[data-smoof-number-color-input]') +
        sizeRow('number') +
        letterSpacingRow(numberState.letterSpacing) +
        row(t('Pillenrahmen', 'Pill outline'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="pill-toggle"><span>${numberState.pillVisible ? t('Aktiv', 'Active') : t('Aus', 'Off')}</span><small>${numberState.pillVisible ? t('Deaktivieren', 'Disable') : t('Aktivieren', 'Enable')} →</small></button>`) +
        (numberState.pillVisible ? hexColorRow(t('Konturfarbe', 'Outline colour'), 'pill-stroke-color', numberState.pillStrokeColor) +
          hexColorRow(t('Füllfarbe', 'Fill colour'), 'pill-fill-color', numberState.pillFillColor) +
          row(t('Füllung', 'Fill'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="pill-fill-toggle"><span>${numberState.pillFillVisible ? t('Farbig', 'Coloured') : t('Transparent', 'Transparent')}</span><small>${numberState.pillFillVisible ? t('Transparent schalten', 'Make transparent') : t('Farbe verwenden', 'Use colour')} →</small></button>`) +
          row(t('Konturstärke', 'Outline width'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-stroke-minus">−</button><span>${Math.round(numberState.pillStrokeWidth * 100)}%</span><button type="button" data-smoof-ui-action="pill-stroke-plus">+</button></div>`) +
          row(t('Padding horizontal', 'Horizontal padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-x-minus">−</button><span>${Math.round(numberState.pillPaddingX * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-x-plus">+</button></div>`) +
          row(t('Padding vertikal', 'Vertical padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-y-minus">−</button><span>${Math.round(numberState.pillPaddingY * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-y-plus">+</button></div>`) : '') +
        opacityRow() +
        resetButton('number');
    }
    if (descriptor.kind === 'brand') return colorRow(t('Farbe', 'Colour'), 'brand-color', '[data-smoof-brand-color-input]') + opacityRow();
    if (descriptor.kind === 'nfc') {
      const nfc = window.SmoofNfcTools?.getState?.() || {
        iconColor: '#0d0d0d',
        circleColor: '#ffffff',
        circleTransparent: false
      };
      const nfcColor = (label, name, value) => colorRowValue(label, name, value);
      return nfcColor(t('Symbol', 'Icon'), 'nfc-icon-color', nfc.iconColor) +
        nfcColor(t('Kreisfläche', 'Circle fill'), 'nfc-circle-color', nfc.circleColor) +
        row(t('Hintergrund', 'Background'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="nfc-transparency"><span>${nfc.circleTransparent ? t('Transparent', 'Transparent') : t('Farbig', 'Coloured')}</span><small>${nfc.circleTransparent ? t('Farbig schalten', 'Use colour') : t('Transparent schalten', 'Make transparent')} →</small></button>`) +
        opacityRow() +
        `<div data-smoof-ui-locked-note>${t('Im QR-Code rastet das NFC-Symbol ausschließlich exakt in der Mitte ein. Außerhalb der QR-Schutzzone ist es frei platzierbar.', 'Inside the QR code the NFC icon snaps exactly to the centre. Outside the QR protection zone it can be positioned freely.')}</div>` +
        resetButton('nfc');
    }
    if (descriptor.kind === 'payments') {
      const payments = window.SmoofPaymentTools?.getState?.() || {
        selected: [], color: '#000000', scale: 1
      };
      return row(t('Anbieter', 'Providers'), paymentProviderGrid(payments)) +
        colorRowValue(t('Farbe', 'Colour'), 'payment-color', payments.color) +
        row(t('Größe', 'Size'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="payment-size-minus" aria-label="${t('Verkleinern', 'Decrease')}">−</button><span data-smoof-ui-payment-scale>${Math.round(payments.scale * 100)}%</span><button type="button" data-smoof-ui-action="payment-size-plus" aria-label="${t('Vergrößern', 'Increase')}">+</button></div>`) +
        opacityRow() +
        resetButton('payment');
    }
    if (descriptor.kind === 'background') {
      if (backgroundLocked) {
        return `<div data-smoof-ui-locked-note><strong>${t('Für DOT ME gesperrt', 'Locked for DOT ME')}</strong><br>${t('Die Edelstahloberfläche gehört zum Produkt und kann nicht verändert, eingefärbt oder durch ein Bild ersetzt werden.', 'The stainless-steel surface belongs to the product and cannot be recoloured or replaced by an image.')}</div>`;
      }
      const bridgedImage = window.SmoofBackgroundImageBridge?.getState?.();
      const image = (bridgedImage?.hasImage ? bridgedImage : window.SmoofBackgroundImageTools?.getState?.()) || {
        hasImage: false,
        fileName: ''
      };
      const gradient = window.SmoofBackgroundGradientTools?.getState?.() || {
        enabled: false,
        color1: '#000000',
        color2: '#ffffff',
        angle: 0,
        overlayEnabled: false,
        overlayColor: '#000000',
        overlayOpacity: 0.3
      };
      const fileName = image.fileName || t('Kein Bild ausgewählt', 'No image selected');
      const imagePositionX = Math.max(0, Math.min(1, Number.isFinite(Number(image.positionX)) ? Number(image.positionX) : 0.5));
      const imagePositionY = Math.max(0, Math.min(1, Number.isFinite(Number(image.positionY)) ? Number(image.positionY) : 0.5));
      const imageScale = Math.max(0.05, Math.min(3, Number(image.scale) || 1));
      const safeFileName = escapeHtml(fileName);
      return backgroundColorRow(t('Grundfarbe', 'Base colour')) +
        opacityRow() +
        row(t('Verlauf', 'Gradient'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="background-gradient-toggle"><span>${gradient.enabled ? t('Aktiv', 'Active') : t('Aus', 'Off')}</span><small>${gradient.enabled ? t('Deaktivieren', 'Disable') : t('Aktivieren', 'Enable')} →</small></button>`) +
        (gradient.enabled
          ? hexColorRow(t('Startfarbe', 'Start colour'), 'background-gradient-color-1', gradient.color1) +
            hexColorRow(t('Endfarbe', 'End colour'), 'background-gradient-color-2', gradient.color2) +
            row(t('Richtung', 'Direction'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-gradient-angle-minus" aria-label="${t('Nach links drehen', 'Rotate left')}">−</button><span data-smoof-ui-gradient-angle>${Math.round(gradient.angle)}°</span><button type="button" data-smoof-ui-action="background-gradient-angle-plus" aria-label="${t('Nach rechts drehen', 'Rotate right')}">+</button></div>`)
          : '') +
        row(t('Bild', 'Image'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="background-upload"><span>${image.hasImage ? t('Bild ersetzen', 'Replace image') : t('Bild hochladen', 'Upload image')}</span><small>PNG, JPG, WebP →</small></button>`) +
        `<div data-smoof-ui-locked-note><strong data-smoof-ui-file-name title="${safeFileName}">${safeFileName}</strong>${t('Das Bild füllt die Druckfläche. Größe und Ausschnitt können angepasst werden.', 'The image fills the print area. Size and crop can be adjusted.')}</div>` +
        (image.hasImage
          ? row(t('Bildgröße', 'Image size'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-image-scale-minus">−</button><span>${Math.round(imageScale * 100)}%</span><button type="button" data-smoof-ui-action="background-image-scale-plus">+</button></div>`) +
            row(t('Horizontal', 'Horizontal'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-image-x-minus">−</button><span>${Math.round((imagePositionX - 0.5) * 200)}%</span><button type="button" data-smoof-ui-action="background-image-x-plus">+</button></div>`) +
            row(t('Vertikal', 'Vertical'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-image-y-minus">−</button><span>${Math.round((imagePositionY - 0.5) * 200)}%</span><button type="button" data-smoof-ui-action="background-image-y-plus">+</button></div>`) +
            `<div data-smoof-ui-actions data-single="true"><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="background-image-position-reset">${icon('reset')} ${t('Bildausschnitt zurücksetzen', 'Reset image crop')}</button></div>`
          : '') +
        row(t('Overlay', 'Overlay'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="background-overlay-toggle"><span>${gradient.overlayEnabled ? t('Aktiv', 'Active') : t('Aus', 'Off')}</span><small>${gradient.overlayEnabled ? t('Deaktivieren', 'Disable') : t('Aktivieren', 'Enable')} →</small></button>`) +
        (gradient.overlayEnabled
          ? hexColorRow(t('Overlayfarbe', 'Overlay colour'), 'background-overlay-color', gradient.overlayColor) +
            row(t('Overlaystärke', 'Overlay strength'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-overlay-opacity-minus" aria-label="${t('Overlay reduzieren', 'Reduce overlay')}">−</button><span data-smoof-ui-overlay-opacity>${Math.round(gradient.overlayOpacity * 100)}%</span><button type="button" data-smoof-ui-action="background-overlay-opacity-plus" aria-label="${t('Overlay verstärken', 'Increase overlay')}">+</button></div>`)
          : '') +
        (image.hasImage
          ? `<div data-smoof-ui-actions data-single="true"><button type="button" data-smoof-ui-icon-button data-smoof-ui-danger data-smoof-ui-action="background-remove">${icon('trash')} ${t('Hintergrundbild entfernen', 'Remove background image')}</button></div>`
          : '');
    }
    return '';
  }

  function panelHead(descriptor, mode) {
    const hideable = Boolean(descriptor && descriptor.hideable);
    const start = mode === 'layers-detail'
      ? `<button type="button" data-smoof-ui-panel-back aria-label="${t('Zurück', 'Back')}">${icon('back')}</button>`
      : `<span data-smoof-ui-panel-symbol>${icon(descriptor.symbol)}</span>`;
    const visibility = hideable
      ? `<button type="button" data-smoof-ui-panel-visibility data-smoof-ui-action="item-visibility" aria-label="${isVisible(selectedId) ? t('Element ausblenden', 'Hide element') : t('Element einblenden', 'Show element')}">${icon(isVisible(selectedId) ? 'eye' : 'eyeOff')}</button>`
      : '';
    return `<header data-smoof-ui-panel-head data-has-visibility="${hideable}">${start}<span><strong data-smoof-ui-panel-title>${descriptor.title}</strong><small data-smoof-ui-panel-copy>${descriptor.copy}</small></span>${visibility}<button type="button" data-smoof-ui-panel-close aria-label="${t('Schließen', 'Close')}">${icon('close')}</button></header>`;
  }

  function installPanelScrollAffordance(panel) {
    panelScrollCleanups.get(panel)?.();
    panelScrollCleanups.delete(panel);

    const scroller = panel.querySelector(
      '[data-smoof-ui-panel-body], [data-smoof-ui-layer-list]'
    );
    if (!scroller) return;

    const footer = document.createElement('div');
    footer.dataset.smoofUiScrollAffordance = 'true';
    footer.innerHTML = `<button type="button" data-smoof-ui-scroll-more aria-label="${t('Weitere Einstellungen anzeigen', 'Show more settings')}"><span>${t('Mehr', 'More')}</span><span aria-hidden="true">↓</span></button>`;
    panel.appendChild(footer);

    const button = footer.querySelector('[data-smoof-ui-scroll-more]');
    const update = () => {
      const maximum = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
      const scrollable = maximum > 2;
      const hasMore = scrollable && scroller.scrollTop < maximum - 2;
      panel.dataset.smoofUiScrollable = String(scrollable);
      panel.dataset.smoofUiHasMore = String(hasMore);
      button.tabIndex = hasMore ? 0 : -1;
      button.setAttribute('aria-hidden', String(!hasMore));
    };

    const scrollMore = () => {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      scroller.scrollBy({
        top: Math.max(80, Math.round(scroller.clientHeight * 0.72)),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    };

    scroller.addEventListener('scroll', update, { passive: true });
    button.addEventListener('click', scrollMore);

    const resizeObserver = typeof ResizeObserver === 'function'
      ? new ResizeObserver(update)
      : null;
    resizeObserver?.observe(scroller);
    if (scroller.firstElementChild) resizeObserver?.observe(scroller.firstElementChild);

    panelScrollCleanups.set(panel, () => {
      scroller.removeEventListener('scroll', update);
      button.removeEventListener('click', scrollMore);
      resizeObserver?.disconnect();
    });

    requestAnimationFrame(() => requestAnimationFrame(update));
  }

  function capturePanelScroll(panel, key) {
    const scroller = panel?.querySelector(
      '[data-smoof-ui-panel-body], [data-smoof-ui-layer-list]'
    );
    const sameView = panel?.dataset.smoofUiScrollKey === key;
    return {
      key,
      top: sameView && scroller ? Math.max(0, scroller.scrollTop) : 0
    };
  }

  function restorePanelScroll(panel, snapshot) {
    if (!panel || !snapshot) return;
    panel.dataset.smoofUiScrollKey = snapshot.key;
    const scroller = panel.querySelector(
      '[data-smoof-ui-panel-body], [data-smoof-ui-layer-list]'
    );
    if (!scroller) return;

    const restore = () => {
      if (!scroller.isConnected || panel.dataset.smoofUiScrollKey !== snapshot.key) return;
      const maximum = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
      scroller.scrollTop = Math.min(snapshot.top, maximum);
    };

    restore();
    requestAnimationFrame(restore);
  }

  function activePercentageInputIn(panel) {
    const active = document.activeElement;
    return Boolean(
      panel &&
      active instanceof HTMLInputElement &&
      active.matches('[data-smoof-percent-input]') &&
      panel.contains(active)
    );
  }

  function renderContext() {
    if (activePercentageInputIn(context)) return;
    if (!personalizedDesignSelected()) {
      context.dataset.open = 'false';
      return;
    }
    const descriptor = descriptors()[selectedId];
    source = descriptor ? sourceFor(selectedId) : null;
    if (!descriptor || layersOpen) {
      context.dataset.open = 'false';
      return;
    }
    const scrollSnapshot = capturePanelScroll(context, `context:${selectedId}`);
    context.innerHTML = panelHead(descriptor, 'context') + `<div data-smoof-ui-panel-body>${detailBody(descriptor)}</div>`;
    context.dataset.smoofUiItemId = selectedId;
    context.dataset.open = 'true';
    installPanelScrollAffordance(context);
    restorePanelScroll(context, scrollSnapshot);
    requestAnimationFrame(() => {
      positionContext();
    });
  }

  function layerRows() {
    const customTextIds = (window.SmoofCustomTextTools?.getStates?.() || []).filter(state => state.enabled).map(state => state.id);
    const customPictogramIds = (window.SmoofCustomPictogramTools?.getStates?.() || []).filter(state => state.enabled).map(state => state.id);
    const socialPlatformIds = Object.keys(window.SmoofSocialPlatformTools?.getState?.().objects || {}).map(id => `social-platform-${id}`);
    const order = ['text-0', 'text-1', 'text-2', ...customTextIds, 'arrow-left', 'arrow-right', ...customPictogramIds, 'logo', 'logo-copy', 'logo-2', 'payments', ...socialPlatformIds, 'table-number', 'branding-dot', 'nfc', 'qr', 'background'];
    const map = descriptors();
    return order.filter(id => {
      if (id === 'nfc') return window.SmoofNfcTools?.isActive?.();
      if (id === 'logo-copy') return window.SmoofLogoCopyTools?.getState?.()?.enabled;
      if (id === 'logo-2') return window.SmoofLogoDuplicateTools?.getState?.()?.hasLogo;
      if (id === 'payments') {
        const selected = window.SmoofPaymentTools?.getState?.()?.selected;
        return Array.isArray(selected) && selected.length > 0;
      }
      return true;
    }).map(id => {
      const item = map[id];
      const visibility = Boolean(item.hideable);
      const locked = item.locked;
      const action = visibility
        ? `<button type="button" data-smoof-ui-layer-action="${id}" aria-label="${t('Sichtbarkeit ändern', 'Change visibility')}">${icon(isVisible(id) ? 'eye' : 'eyeOff')}</button>`
        : `<span data-smoof-ui-layer-action>${icon(locked ? 'lock' : 'editor')}</span>`;
      return `<div data-smoof-ui-layer="${id}" data-editable="${String(!item.locked)}"><span data-smoof-ui-layer-symbol>${icon(item.symbol)}</span><span><strong data-smoof-ui-layer-name>${item.title}</strong><small data-smoof-ui-layer-copy>${item.copy}</small></span>${action}</div>`;
    }).join('');
  }

  function renderLayers() {
    if (activePercentageInputIn(layers)) return;
    if (!layersOpen) return;
    const scrollKey = layersPage === 'detail'
      ? `layers:detail:${selectedId}`
      : 'layers:list';
    const scrollSnapshot = capturePanelScroll(layers, scrollKey);
    if (layersPage === 'detail') {
      const descriptor = descriptors()[selectedId];
      source = descriptor ? sourceFor(selectedId) : null;
      if (!descriptor) { layersPage = 'list'; renderLayers(); return; }
      layers.innerHTML = panelHead(descriptor, 'layers-detail') + `<div data-smoof-ui-panel-body>${detailBody(descriptor)}</div>`;
      layers.dataset.smoofUiItemId = selectedId;
    } else {
      delete layers.dataset.smoofUiItemId;
      layers.innerHTML = `<header data-smoof-ui-panel-head><span data-smoof-ui-panel-symbol>${icon('layers')}</span><span><strong data-smoof-ui-panel-title>${t('Ebenen', 'Layers')}</strong><small data-smoof-ui-panel-copy>${t('Element auswählen und bearbeiten', 'Choose and edit an element')}</small></span><button type="button" data-smoof-ui-panel-close aria-label="${t('Schließen', 'Close')}">${icon('close')}</button></header><div data-smoof-ui-layer-list>${layerRows()}</div>`;
    }
    installPanelScrollAffordance(layers);
    restorePanelScroll(layers, scrollSnapshot);
    requestAnimationFrame(() => {
      positionLayers();
    });
  }

  function positionContext() {
    if (!context || context.dataset.open !== 'true' || mobile.matches) return;
    const item = visibleItemFor(selectedId);
    const toolbarAction = selectedId === 'payments' || selectedId === 'add' || selectedId === 'social-library'
      ? 'add'
      : selectedId === 'templates'
        ? 'templates'
      : selectedId === 'downloads'
        ? 'save-design'
        : 'layers';
    const toolbarAnchor = commandbar?.querySelector(
      `[data-smoof-ui-command-action="${toolbarAction}"]`
    ) || commandbar;
    const anchor = item || toolbarAnchor;
    if (!anchor) return;
    const a = anchor.getBoundingClientRect();
    const anchoredToToolbar = !item;
    context.style.maxHeight = `${Math.max(180, innerHeight - 24)}px`;
    const b = context.getBoundingClientRect();
    let left = anchoredToToolbar ? a.left + (a.width - b.width) / 2 : a.right + 14;
    if (!anchoredToToolbar && left + b.width > innerWidth - 12) left = a.left - b.width - 14;
    left = Math.max(12, Math.min(left, innerWidth - b.width - 12));
    let top = anchoredToToolbar ? a.bottom + 10 : a.top + (a.height - b.height) / 2;
    top = Math.max(12, Math.min(top, innerHeight - b.height - 12));
    context.style.left = `${Math.round(left)}px`;
    context.style.top = `${Math.round(top)}px`;
  }

  function positionLayers() {
    if (!layers || !commandbar || mobile.matches) return;
    const a = commandbar.getBoundingClientRect();
    const top = Math.max(12, a.bottom + 10);
    layers.style.maxHeight = `${Math.max(180, innerHeight - top - 12)}px`;
    const b = layers.getBoundingClientRect();
    let left = a.left + (a.width - b.width) / 2;
    left = Math.max(12, Math.min(left, innerWidth - b.width - 12));
    layers.style.left = `${Math.round(left)}px`;
    layers.style.top = `${Math.round(top)}px`;
  }

  function commandbarAnchor() {
    const candidates = Array.from(document.querySelectorAll(
      '.po-livePreview-root, media-gallery.product__gallery, .product__gallery'
    ));

    return candidates.find(candidate => {
      const rect = candidate.getBoundingClientRect();
      const style = getComputedStyle(candidate);
      return style.display !== 'none' && rect.width > 240 && rect.height > 240;
    }) || visibleItemFor('background');
  }

  function ensureCommandbarHost(anchor) {
    if (!anchor || !anchor.parentNode || !commandbar) return;

    const flowAnchor = anchor.matches('.po-livePreview-root')
      ? (anchor.closest('media-gallery.product__gallery, .product__gallery') || anchor)
      : anchor;

    if (!flowAnchor.parentNode) return;

    if (commandbarFlowParent && commandbarFlowParent !== flowAnchor.parentNode) {
      delete commandbarFlowParent.dataset.smoofUiGalleryFlow;
    }
    commandbarFlowParent = flowAnchor.parentNode;
    commandbarFlowParent.dataset.smoofUiGalleryFlow = 'true';

    if (!commandbarHost || !commandbarHost.isConnected) {
      commandbarHost = document.createElement('div');
      commandbarHost.dataset.smoofUiCommandbarHost = 'true';
      commandbarHost.dataset.smoofEditorItem = 'modern-ui-control';
    }

    if (
      commandbarHost.parentNode !== flowAnchor.parentNode ||
      commandbarHost.nextSibling !== flowAnchor
    ) {
      flowAnchor.parentNode.insertBefore(commandbarHost, flowAnchor);
    }

    if (commandbar.parentNode !== commandbarHost) {
      commandbarHost.append(commandbar);
    }
  }

  function positionCommandbar() {
    if (!commandbar) return;
    const anchor = commandbarAnchor();
    if (!anchor) return;
    ensureCommandbarHost(anchor);
    commandbar.style.removeProperty('left');
    commandbar.style.removeProperty('top');
  }

  function legacyPanel(action) {
    const selector = action === 'help' ? '[data-smoof-guide-legend]' : '[data-smoof-reset-menu]';
    return document.querySelector(selector);
  }

  function ensureLegacyPanelShell(action, panel) {
    if (!panel || panel.dataset.smoofUiLegacyShell === 'true') return;

    const isHelp = action === 'help';
    const header = document.createElement('header');
    header.dataset.smoofUiPanelHead = 'true';
    header.dataset.smoofUiLegacyHeader = action;
    header.innerHTML = [
      `<span data-smoof-ui-panel-symbol>${icon(isHelp ? 'help' : 'reset')}</span>`,
      '<span>',
      `<strong data-smoof-ui-panel-title>${isHelp ? t('Hinweise zur Druckfläche', 'Print area guidance') : t('Zurücksetzen', 'Reset')}</strong>`,
      `<small data-smoof-ui-panel-copy>${isHelp ? t('Sicherheitszonen und Hilfslinien', 'Safety zones and guides') : t('Layout oder gesamtes Design wählen', 'Choose layout or entire design')}</small>`,
      '</span>',
      `<button type="button" data-smoof-ui-panel-close aria-label="${t('Schließen', 'Close')}">${icon('close')}</button>`
    ].join('');

    const body = document.createElement('div');
    body.dataset.smoofUiLegacyBody = action;
    while (panel.firstChild) body.append(panel.firstChild);

    if (isHelp) {
      const onboarding = document.createElement('section');
      onboarding.dataset.smoofUiHelpOnboarding = 'true';
      onboarding.innerHTML = `<strong>${t('Einführung in den SMOOF DOTS Editor', 'Introduction to the SMOOF DOTS Editor')}</strong><p>${t('Lernen Sie die wichtigsten Bereiche kennen, ohne Ihr Design zu verändern.', 'Explore the most important areas without changing your design.')}</p><button type="button" data-smoof-editor-tour-restart>${t('Einführung erneut starten', 'Restart introduction')}</button>`;
      body.prepend(onboarding);
    }

    panel.append(header, body);
    panel.dataset.smoofUiLegacyShell = 'true';

    header.querySelector('[data-smoof-ui-panel-close]')?.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      if (isHelp) closeLegacyHelp();
      else closeLegacyReset();
    });
  }

  function legacyPanelOpen(action) {
    const panel = legacyPanel(action);
    if (!panel || panel.hidden) return false;
    const style = getComputedStyle(panel);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function closeLegacyHelp() {
    const panel = legacyPanel('help');
    if (panel) {
      panel.style.removeProperty('display');
      panel.hidden = true;
    }
    const native = document.querySelector('[data-smoof-guide-button]');
    if (native) native.setAttribute('aria-expanded', 'false');
    const modern = commandbar?.querySelector('[data-smoof-ui-command-action="help"]');
    if (modern) modern.setAttribute('aria-expanded', 'false');
    const previewRoot = document.querySelector('.po-livePreview-root[data-smoof-legend-open="true"]');
    if (previewRoot) previewRoot.removeAttribute('data-smoof-legend-open');
  }

  function openLegacyHelp() {
    const panel = legacyPanel('help');
    if (!panel) return;

    ensureLegacyPanelShell('help', panel);

    closeLegacyReset();
    if (layersOpen) setLayersOpen(false);
    if (context) context.dataset.open = 'false';

    panel.hidden = false;
    panel.dataset.smoofModernHelp = 'true';
    panel.style.setProperty('display', 'grid', 'important');

    const native = document.querySelector('[data-smoof-guide-button]');
    if (native) native.setAttribute('aria-expanded', 'true');

    const modern = commandbar?.querySelector('[data-smoof-ui-command-action="help"]');
    if (modern) modern.setAttribute('aria-expanded', 'true');

    const previewRoot = document.querySelector('.po-livePreview-root');
    if (previewRoot) previewRoot.dataset.smoofLegendOpen = 'true';

    window.dispatchEvent(new CustomEvent('smoof:editor-select', { detail: { id: '' } }));
    positionLegacyPopover('help');
    requestAnimationFrame(() => positionLegacyPopover('help'));
  }

  function closeLegacyReset() {
    const panel = legacyPanel('reset');
    if (panel) {
      panel.style.removeProperty('display');
      panel.style.removeProperty('visibility');
      panel.hidden = true;
    }
    const native = document.querySelector('[data-smoof-reset-button]');
    if (native) native.setAttribute('aria-expanded', 'false');
    const modern = commandbar?.querySelector('[data-smoof-ui-command-action="reset"]');
    if (modern) modern.setAttribute('aria-expanded', 'false');
  }

  function openLegacyReset() {
    let panel = legacyPanel('reset');
    const native = document.querySelector('[data-smoof-reset-button]');

    /* Das stabile Reset-Liquid erzeugt sein Menü erst beim ersten Öffnen. */
    if (!panel && native) {
      native.click();
      panel = legacyPanel('reset');
    }
    if (!panel) return;

    ensureLegacyPanelShell('reset', panel);

    closeLegacyHelp();
    if (layersOpen) setLayersOpen(false);
    if (context) context.dataset.open = 'false';

    panel.dataset.smoofModernReset = 'true';
    panel.style.setProperty('visibility', 'hidden', 'important');
    panel.hidden = false;
    panel.style.setProperty('display', 'grid', 'important');

    if (native) native.setAttribute('aria-expanded', 'true');
    const modern = commandbar?.querySelector('[data-smoof-ui-command-action="reset"]');
    if (modern) modern.setAttribute('aria-expanded', 'true');

    positionLegacyPopover('reset');
    requestAnimationFrame(() => {
      if (!panel.hidden) {
        positionLegacyPopover('reset');
        panel.style.removeProperty('visibility');
      }
    });
  }

  function positionLegacyPopover(action) {
    if (!commandbar) return;
    const panel = legacyPanel(action);
    if (!panel) return;
    const style = getComputedStyle(panel);
    const measuringReset = action === 'reset' && panel.dataset.smoofModernReset === 'true';
    if (style.display === 'none' || (style.visibility === 'hidden' && !measuringReset)) return;
    const anchor = commandbar.getBoundingClientRect();
    const box = panel.getBoundingClientRect();
    let left = anchor.right - box.width;
    left = Math.max(12, Math.min(left, innerWidth - box.width - 12));
    const top = Math.max(12, anchor.bottom + 10);
    const availableHeight = Math.max(180, innerHeight - top - 12);
    if (action === 'help') {
      panel.dataset.smoofModernHelp = 'true';
      panel.style.setProperty('--smoof-modern-help-left', `${Math.round(left)}px`);
      panel.style.setProperty('--smoof-modern-help-top', `${Math.round(top)}px`);
      panel.style.setProperty('--smoof-modern-help-height', `${Math.round(availableHeight)}px`);
    } else {
      panel.dataset.smoofModernReset = 'true';
      panel.style.setProperty('--smoof-modern-reset-left', `${Math.round(left)}px`);
      panel.style.setProperty('--smoof-modern-reset-top', `${Math.round(top)}px`);
      panel.style.setProperty('--smoof-modern-reset-height', `${Math.round(availableHeight)}px`);
    }
  }

  function syncCommandbar() {
    if (!commandbar) return;
    if (!syncPersonalizationGate()) return;
    const layersButton = commandbar.querySelector('[data-smoof-ui-command-action="layers"]');
    if (layersButton) layersButton.setAttribute('aria-expanded', String(layersOpen));
    const addButton = commandbar.querySelector('[data-smoof-ui-command-action="add"]');
    if (addButton) {
      const addOpen = (selectedId === 'add' || selectedId === 'payments') && context?.dataset.open === 'true';
      addButton.setAttribute('aria-expanded', String(addOpen));
    }
    const downloadsButton = commandbar.querySelector('[data-smoof-ui-command-action="save-design"]');
    if (downloadsButton) {
      const downloadsOpen = selectedId === 'downloads' && context?.dataset.open === 'true';
      downloadsButton.setAttribute('aria-expanded', String(downloadsOpen));
    }
    const templatesButton = commandbar.querySelector('[data-smoof-ui-command-action="templates"]');
    if (templatesButton) {
      const templatesOpen = selectedId === 'templates' && context?.dataset.open === 'true';
      templatesButton.setAttribute('aria-expanded', String(templatesOpen));
    }
    const guideNative = document.querySelector('[data-smoof-guide-visibility-button]');
    const guideButton = commandbar.querySelector('[data-smoof-ui-command-action="guides"]');
    if (guideButton) {
      const active = guideNative?.dataset.active === 'true' || guideNative?.getAttribute('aria-pressed') === 'true';
      guideButton.dataset.active = String(active);
      guideButton.setAttribute('aria-pressed', String(active));
    }
    const helpButton = commandbar.querySelector('[data-smoof-ui-command-action="help"]');
    if (helpButton) helpButton.setAttribute('aria-expanded', String(legacyPanelOpen('help')));
    const resetButton = commandbar.querySelector('[data-smoof-ui-command-action="reset"]');
    if (resetButton) resetButton.setAttribute('aria-expanded', String(legacyPanelOpen('reset')));
    syncHistoryButtons();
    positionCommandbar();
  }

  function proxy(selector) { return source ? source.querySelector(selector) : null; }
  function clickNative(selector) { const el = proxy(selector); if (el && !el.disabled) el.click(); }

  function finishFontSelection(family) {
    const clean = cleanFontFamily(family);
    const itemId = fontPickerTarget;
    if (!itemId || !clean || !/^[a-z0-9 ._-]+$/i.test(clean)) return false;
    const customFont = window.SmoofCustomFontRegistry?.isCustomFamily?.(clean);
    let applied = false;
    if (/^text-[0-2]$/.test(itemId)) {
      if (customFont) window.SmoofTextTools?.setStyle?.(Number(itemId.split('-')[1]), 'Normal');
      applied = Boolean(window.SmoofTextTools?.setFont?.(Number(itemId.split('-')[1]), clean));
    } else if (/^custom-text-[1-3]$/.test(itemId)) {
      if (customFont) window.SmoofCustomTextTools?.setStyle?.(itemId, 'Normal');
      applied = Boolean(window.SmoofCustomTextTools?.setFont?.(itemId, clean));
    } else if (itemId === 'table-number') {
      if (customFont) {
        const styleSelect = document.querySelector('[data-smoof-number-style-select]');
        if (styleSelect) setNativeValue(styleSelect, 'Normal', true);
      }
      applied = Boolean(window.SmoofNumberHistory?.setFont?.(clean));
    }
    if (!applied) return false;
    selectedId = itemId;
    fontPickerTarget = '';
    fontPickerInitialFamily = '';
    root.removeAttribute('data-smoof-font-picker-active');
    scheduleHistoryCapture(80);
    setTimeout(() => {
      if (layersOpen) renderLayers();
      else renderContext();
      syncCommandbar();
    }, 40);
    return true;
  }

  function resetFontPickerState() {
    const hadPendingState = Boolean(
      fontPickerTarget ||
      root.hasAttribute('data-smoof-font-picker-active')
    );
    fontPickerTarget = '';
    fontPickerInitialFamily = '';
    root.removeAttribute('data-smoof-font-picker-active');
    if (!hadPendingState) return;
    setTimeout(() => {
      if (layersOpen) renderLayers();
      else renderContext();
      syncCommandbar();
    }, 0);
  }

  function currentFontPickerTrigger() {
    const hook = document.querySelector('[data-smoof-font-tool]');
    const option = optionRoot(FONT_OPTION_ID);
    return (hook?.matches?.('button, [role="button"], [role="combobox"]') ? hook : null) ||
      hook?.querySelector?.('button, [role="button"], [role="combobox"]') ||
      option?.querySelector('button[aria-haspopup="listbox"], [role="combobox"], button') ||
      null;
  }

  function openFontPicker(itemId = selectedId) {
    if (!/^text-[0-2]$/.test(itemId) && !/^custom-text-[1-3]$/.test(itemId) && itemId !== 'table-number') return false;
    window.SmoofTextTools?.freezeFonts?.();
    window.SmoofNumberHistory?.freezeFont?.();
    fontPickerTarget = itemId;
    fontPickerInitialFamily = selectedGoogleFont();
    root.dataset.smoofFontPickerActive = 'true';
    if (context) context.dataset.open = 'false';
    if (layers) layers.dataset.open = 'false';
    const openExistingPicker = () => {
      if (fontPickerTarget !== itemId) return;
      const publicPicker = window.SmoofFontPicker || window.SmoofGoogleFontPicker;
      if (typeof publicPicker?.open === 'function') {
        publicPicker.open();
      } else {
        const trigger = currentFontPickerTrigger();
        if (!trigger || trigger.disabled) {
          resetFontPickerState();
          return;
        }
        trigger.click();
      }
      setTimeout(() => {
        if (fontPickerTarget !== itemId) return;
        const pickerOpen = Boolean(document.querySelector('.smoof-font-backdrop[data-open="true"]'));
        if (pickerOpen) return;
        resetFontPickerState();
      }, 160);
    };
    if (itemId === 'table-number') setTimeout(openExistingPicker, 80);
    else openExistingPicker();
    return true;
  }

  function panelItemId(panel) {
    return panel?.dataset.smoofUiItemId || selectedId;
  }

  function applySelect(name, value, panel) {
    const itemId = panelItemId(panel);
    const index = itemId.split('-')[1];
    suppressSelectionRenderId = itemId;
    suppressSelectionRenderUntil = Date.now() + 800;
    if (name === 'pictogram' && window.SmoofArrowTools?.setSymbol) {
      window.SmoofArrowTools.setSymbol(itemId.split('-')[1], value);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (name === 'logo-background-shape' && window.SmoofLogoBackgroundTools?.setShape) {
      window.SmoofLogoBackgroundTools.setShape(itemId, value);
      selectedId = itemId;
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (name === 'custom-text-style' && window.SmoofCustomTextTools) {
      window.SmoofCustomTextTools.setStyle(itemId, value);
      const select = panel.querySelector(`[data-smoof-ui-select="${name}"]`);
      if (select) select.value = value;
      return;
    }
    if (name === 'text-style' && window.SmoofTextTools) {
      window.SmoofTextTools.setStyle(Number(index), value);
      const select = panel.querySelector(`[data-smoof-ui-select="${name}"]`);
      if (select) select.value = value;
      return;
    }
    const targetSource = sourceFor(itemId);
    const selector = name === 'text-style'
      ? `[data-smoof-text-style-select="${index}"]`
      : '[data-smoof-number-style-select]';
    const native = targetSource?.querySelector(selector);
    if (!native) return;
    setNativeValue(native, value, true);
    const select = panel.querySelector(`[data-smoof-ui-select="${name}"]`);
    if (select) select.value = value;
  }

  function applyColor(name, value, commit, container) {
    if (backgroundLocked && String(name || '').startsWith('background-')) return;
    if (laserMonochromeActive()) {
      const colorInput = container?.querySelector?.(`[data-smoof-ui-color="${name}"]`);
      const colorWrap = colorInput?.closest('[data-smoof-ui-color-wrap]');
      const label = colorWrap?.querySelector('[data-smoof-ui-color-value]');
      const swatch = colorWrap?.querySelector('[data-smoof-ui-color-swatch]');
      const hexInput = container?.querySelector?.(`[data-smoof-ui-hex-color="${name}"]`);
      if (colorInput) colorInput.value = '#000000';
      if (label) label.textContent = '#000000';
      if (swatch) swatch.style.backgroundColor = '#000000';
      if (hexInput) {
        hexInput.value = '#000000';
        hexInput.setAttribute('aria-invalid', 'false');
      }
      window.SmoofDotMePolicy?.enforceNow?.('theme-ui-colour-attempt');
      return false;
    }
    const itemId = panelItemId(container);
    const index = itemId.split('-')[1];
    suppressSelectionRenderId = itemId;
    suppressSelectionRenderUntil = Date.now() + 1200;
    if (name === 'custom-text-color' && window.SmoofCustomTextTools) {
      window.SmoofCustomTextTools.setColor(itemId, value, commit);
    } else if (name === 'custom-pictogram-color' && window.SmoofCustomPictogramTools) {
      window.SmoofCustomPictogramTools.setColor(itemId, value, commit);
    } else if ((name === 'pill-stroke-color' || name === 'pill-fill-color') && /^custom-text-[1-3]$/.test(itemId) && window.SmoofCustomTextTools) {
      window.SmoofCustomTextTools.setPillColor(itemId, name === 'pill-fill-color' ? 'fill' : 'stroke', value);
    } else if (name === 'text-color' && window.SmoofTextTools) {
      window.SmoofTextTools.setColor(Number(index), value, commit);
    } else if ((name === 'pill-stroke-color' || name === 'pill-fill-color') && itemId === 'table-number' && window.SmoofNumberHistory) {
      window.SmoofNumberHistory.setPillColor(name === 'pill-fill-color' ? 'fill' : 'stroke', value);
      if (commit) scheduleHistoryCapture(80);
    } else if ((name === 'pill-stroke-color' || name === 'pill-fill-color') && window.SmoofTextTools) {
      window.SmoofTextTools.setPillColor(Number(index), name === 'pill-fill-color' ? 'fill' : 'stroke', value);
    } else if (
      (name === 'arrow-color' || name === 'arrow-label-color') &&
      window.SmoofArrowTools
    ) {
      window.SmoofArrowTools.setColor(
        itemId.split('-')[1],
        name === 'arrow-label-color' ? 'label' : 'arrow',
        value,
        commit
      );
    } else if (
      (name === 'nfc-icon-color' || name === 'nfc-circle-color') &&
      window.SmoofNfcTools?.setColor
    ) {
      window.SmoofNfcTools.setColor(
        name === 'nfc-icon-color' ? 'icon' : 'circle',
        value,
        commit
      );
    } else if (
      (name === 'background-gradient-color-1' || name === 'background-gradient-color-2') &&
      window.SmoofBackgroundGradientTools?.setColor
    ) {
      window.SmoofBackgroundGradientTools.setColor(
        name === 'background-gradient-color-2' ? 'end' : 'start',
        value
      );
    } else if (
      name === 'background-overlay-color' &&
      window.SmoofBackgroundGradientTools?.setOverlayColor
    ) {
      window.SmoofBackgroundGradientTools.setOverlayColor(value);
    } else if (
      name === 'qr-code-color' &&
      window.SmoofQrGeometryTools?.setCodeColor
    ) {
      window.SmoofQrGeometryTools.setCodeColor(value, { commit });
    } else if (
      name === 'qr-backing-color' &&
      window.SmoofQrGeometryTools?.setBackingColor
    ) {
      window.SmoofQrGeometryTools.setBackingColor(value, { commit });
    } else if (
      name === 'payment-color' &&
      window.SmoofPaymentTools?.setColor
    ) {
      window.SmoofPaymentTools.setColor(value);
    } else if (
      name === 'social-platform-color' &&
      window.SmoofSocialPlatformTools?.setColor
    ) {
      window.SmoofSocialPlatformTools.setColor(itemId, value);
    } else if (
      name === 'logo-background-color' &&
      window.SmoofLogoBackgroundTools?.setColor
    ) {
      window.SmoofLogoBackgroundTools.setColor(itemId, value);
    } else {
      const targetSource = sourceFor(itemId);
    const selectors = {
      'text-color': `[data-smoof-text-color-input="${index}"]`,
      'arrow-color': '[data-smoof-arrow-color-input]',
      'arrow-label-color': '[data-smoof-arrow-label-color-input]',
      'number-color': '[data-smoof-number-color-input]',
      'brand-color': '[data-smoof-brand-color-input]',
      'background-color': 'input[type="color"]'
    };
      const native = targetSource?.querySelector(selectors[name]);
    if (!native) return;
    setNativeValue(native, value, commit);
    }
    const colorInput = container.querySelector(`[data-smoof-ui-color="${name}"]`);
    const colorWrap = colorInput?.closest('[data-smoof-ui-color-wrap]');
    const label = colorWrap?.querySelector('[data-smoof-ui-color-value]');
    const swatch = colorWrap?.querySelector('[data-smoof-ui-color-swatch]');
    const hexInput = container.querySelector(`[data-smoof-ui-hex-color="${name}"]`);
    if (colorInput && colorInput.value !== value) colorInput.value = value;
    if (label) label.textContent = value.toUpperCase();
    if (swatch) swatch.style.backgroundColor = value;
    if (hexInput) {
      hexInput.value = value.toUpperCase();
      hexInput.setAttribute('aria-invalid', 'false');
    }
  }

  function applyHexColor(input, commit, panel) {
    if (laserMonochromeActive()) {
      if (input) {
        input.value = '#000000';
        input.setAttribute('aria-invalid', 'false');
      }
      window.SmoofDotMePolicy?.enforceNow?.('theme-ui-hex-attempt');
      return false;
    }
    const value = normalizeHexColor(input?.value, commit);
    if (!value) {
      if (commit) input?.setAttribute('aria-invalid', 'true');
      return false;
    }
    input.setAttribute('aria-invalid', 'false');
    applyColor(input.dataset.smoofUiHexColor, value, commit, panel);
    return true;
  }

  function handleAction(action, panel) {
    if (backgroundLocked && String(action || '').startsWith('background-')) return;
    const itemId = panelItemId(panel);
    const targetSource = sourceFor(itemId);
    const map = {
      'text-minus': '[data-smoof-text-control-button="minus"]',
      'text-plus': '[data-smoof-text-control-button="plus"]',
      'text-reset': '[data-smoof-text-control-button="reset"]',
      'logo-minus': '[data-smoof-logo-control-button="control"]',
      'logo-plus': '[data-smoof-logo-control-button="plus"]',
      'logo-reset': '[data-smoof-logo-control-button="reset"]',
      'number-minus': '[data-smoof-number-control-button="minus"]',
      'number-plus': '[data-smoof-number-control-button="plus"]',
      'number-reset': '[data-smoof-number-control-button="reset"]'
    };
    if (action === 'add-open:payments') {
      togglePaymentsShortcut();
      return;
    }
    if (action === 'add-open:social-platforms') {
      selectedId = 'social-library';
      if (layersOpen) setLayersOpen(false);
      renderContext();
      dispatchSelection('social-library', { openContext: true });
      syncCommandbar();
      return;
    }
    if (action === 'add-open:custom-text') {
      const state = window.SmoofCustomTextTools?.add?.();
      if (!state?.id) return;
      selectedId = state.id;
      if (layersOpen) layersPage = 'detail';
      dispatchSelection(state.id, { openContext: true });
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'add-open:custom-pictogram') {
      const state = window.SmoofCustomPictogramTools?.add?.();
      if (!state?.id) return;
      selectedId = state.id;
      if (layersOpen) layersPage = 'detail';
      dispatchSelection(state.id, { openContext: true });
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'add-open:logo-copy') {
      const state = window.SmoofLogoCopyTools?.getState?.();
      if (!state?.enabled) window.SmoofLogoCopyTools?.toggleEnabled?.();
      selectedId = 'logo-copy';
      if (layersOpen) layersPage = 'detail';
      dispatchSelection('logo-copy', { openContext: true });
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'add-open:logo-2') {
      selectedId = 'logo-2';
      if (layersOpen) layersPage = 'detail';
      dispatchSelection('logo-2', { openContext: true });
      window.SmoofLogoDuplicateTools?.openUpload?.();
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'qr-scale-minus' || action === 'qr-scale-plus') {
      const qr = window.SmoofQrGeometryTools?.getState?.();
      if (!qr) return;
      window.SmoofQrGeometryTools.setScale(
        (Number(qr.scale) || 1) + (action.endsWith('plus') ? 0.1 : -0.1)
      );
      selectedId = 'qr';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'qr-visibility-toggle') {
      window.SmoofQrGeometryTools?.toggleVisibility?.();
      selectedId = 'qr';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'qr-backing-toggle') {
      window.SmoofQrGeometryTools?.toggleBackingVisibility?.();
      selectedId = 'qr';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'qr-reset') {
      window.SmoofQrGeometryTools?.reset?.();
      selectedId = 'qr';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'pictogram-picker-toggle') {
      const side = itemId.split('-')[1] === 'right' ? 'right' : 'left';
      pictogramPickerOpenFor = pictogramPickerOpenFor === side ? '' : side;
      const current = window.SmoofArrowTools?.getState?.(side);
      const iconRecord = window.SmoofPictogramLibrary?.get?.(current?.symbol);
      if (iconRecord?.category) pictogramPickerCategory[side] = iconRecord.category;
      if (layersOpen) renderLayers(); else renderContext();
      if (pictogramPickerOpenFor === side) alignActivePictogramCategory(panel);
      return;
    }
    if (action.startsWith('pictogram-category:')) {
      const side = itemId.split('-')[1] === 'right' ? 'right' : 'left';
      rememberPictogramCategoryScroll(panel, side);
      pictogramPickerOpenFor = side;
      pictogramPickerCategory[side] = action.slice('pictogram-category:'.length) || 'arrows';
      if (layersOpen) renderLayers(); else renderContext();
      restorePictogramCategoryScroll(panel, side);
      return;
    }
    if (action.startsWith('pictogram-select:')) {
      const side = itemId.split('-')[1] === 'right' ? 'right' : 'left';
      const symbol = action.slice('pictogram-select:'.length);
      const applied = window.SmoofArrowTools?.setSymbol?.(side, symbol);
      if (!applied) return;
      pictogramPickerOpenFor = '';
      selectedId = itemId;
      scheduleHistoryCapture(100);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'pictogram-upload') {
      panel.querySelector('[data-smoof-ui-pictogram-upload]')?.click?.();
      return;
    }
    if (action === 'pictogram-color-mode') {
      const side = itemId.split('-')[1] === 'right' ? 'right' : 'left';
      const state = window.SmoofArrowTools?.getState?.(side);
      const applied = window.SmoofArrowTools?.setColorize?.(side, !state?.colorize);
      if (applied == null) return;
      selectedId = `arrow-${side}`;
      scheduleHistoryCapture(100);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-pictogram-picker-toggle') {
      pictogramPickerOpenFor = pictogramPickerOpenFor === itemId ? '' : itemId;
      const current = window.SmoofCustomPictogramTools?.getState?.(itemId);
      const iconRecord = window.SmoofPictogramLibrary?.get?.(current?.symbol);
      if (iconRecord?.category) pictogramPickerCategory[itemId] = iconRecord.category;
      if (layersOpen) renderLayers(); else renderContext();
      if (pictogramPickerOpenFor === itemId) alignActivePictogramCategory(panel);
      return;
    }
    if (action.startsWith('custom-pictogram-category:')) {
      rememberPictogramCategoryScroll(panel, itemId);
      pictogramPickerOpenFor = itemId;
      pictogramPickerCategory[itemId] = action.slice('custom-pictogram-category:'.length) || 'arrows';
      if (layersOpen) renderLayers(); else renderContext();
      restorePictogramCategoryScroll(panel, itemId);
      return;
    }
    if (action.startsWith('custom-pictogram-select:')) {
      const symbol = action.slice('custom-pictogram-select:'.length);
      if (!window.SmoofCustomPictogramTools?.setSymbol?.(itemId, symbol)) return;
      pictogramPickerOpenFor = '';
      selectedId = itemId;
      scheduleHistoryCapture(100);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-pictogram-upload') {
      panel.querySelector('[data-smoof-ui-custom-pictogram-upload]')?.click?.();
      return;
    }
    if (action === 'custom-pictogram-color-mode') {
      const state = window.SmoofCustomPictogramTools?.getState?.(itemId);
      if (!state) return;
      window.SmoofCustomPictogramTools?.setColorize?.(itemId, !state.colorize);
      selectedId = itemId;
      scheduleHistoryCapture(100);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'open-design') {
      window.SmoofDesignFileTools?.open?.();
      return;
    }
    if (action.startsWith('template-category:')) {
      templateCategory = action.slice('template-category:'.length);
      selectedId = 'templates';
      renderContext();
      return;
    }
    if (action.startsWith('template-apply:')) {
      const templateId = action.slice('template-apply:'.length);
      Promise.resolve(window.SmoofTemplateLibrary?.apply?.(templateId)).then(applied => {
        if (!applied) return;
        selectedId = '';
        dispatchSelection('');
        scheduleHistoryCapture(420);
      });
      return;
    }
    if (action === 'download-design') {
      window.SmoofDesignFileTools?.save?.();
      return;
    }
    if (action === 'download-mockup') {
      const run = () => window.SmoofMockupDownload?.download?.();
      if (!run()) window.setTimeout(run, 300);
      return;
    }
    if (action === 'download-proof' || action === 'download-production') {
      const selector = action === 'download-proof'
        ? '[data-smoof-proof-test-button]'
        : '[data-smoof-production-test-button]';
      const trigger = document.querySelector(selector);
      if (trigger && !trigger.disabled) trigger.click();
      else window.setTimeout(() => document.querySelector(selector)?.click?.(), 300);
      return;
    }
    if (action === 'text-font') {
      openFontPicker(itemId);
      return;
    }
    if (action === 'letter-spacing-minus' || action === 'letter-spacing-plus') {
      const delta = action.endsWith('plus') ? 0.01 : -0.01;
      let value = 0;
      if (/^text-[0-2]$/.test(itemId)) {
        const index = Number(itemId.split('-')[1]);
        const state = window.SmoofTextTools?.getPillState?.(index);
        value = window.SmoofTextTools?.setLetterSpacing?.(
          index,
          Number(state?.letterSpacing || 0) + delta
        );
      } else if (/^custom-text-[1-3]$/.test(itemId)) {
        const state = window.SmoofCustomTextTools?.getState?.(itemId);
        value = window.SmoofCustomTextTools?.setLetterSpacing?.(
          itemId,
          Number(state?.letterSpacing || 0) + delta
        )?.letterSpacing;
      } else if (itemId === 'table-number') {
        const state = window.SmoofNumberHistory?.getState?.();
        value = window.SmoofNumberHistory?.setLetterSpacing?.(
          Number(state?.letterSpacing || 0) + delta
        );
      } else {
        return;
      }
      const output = panel.querySelector('[data-smoof-ui-letter-spacing]');
      if (output && Number.isFinite(Number(value))) {
        output.textContent = `${Math.round(Number(value) * 100)}%`;
      }
      scheduleHistoryCapture(80);
      return;
    }
    if (action === 'opacity-minus' || action === 'opacity-plus') {
      if (/^custom-pictogram-[1-3]$/.test(itemId)) {
        const state = window.SmoofCustomPictogramTools?.getState?.(itemId);
        if (!state) return;
        const next = Math.max(0.05, Math.min(1, Number(state.opacity || 1) + (action.endsWith('plus') ? 0.05 : -0.05)));
        window.SmoofCustomPictogramTools.setOpacity(itemId, next);
        const output = panel.querySelector('[data-smoof-ui-opacity-value]');
        if (output) output.textContent = `${Math.round(next * 100)}%`;
        return;
      }
      if (/^custom-text-[1-3]$/.test(itemId)) {
        const state = window.SmoofCustomTextTools?.getState?.(itemId);
        if (!state) return;
        const next = Math.max(0.05, Math.min(1, Number(state.opacity || 1) + (action.endsWith('plus') ? 0.05 : -0.05)));
        window.SmoofCustomTextTools.setOpacity(itemId, next);
        const output = panel.querySelector('[data-smoof-ui-opacity-value]');
        if (output) output.textContent = `${Math.round(next * 100)}%`;
        return;
      }
      const current = window.SmoofLayerOpacityTools?.get?.(itemId);
      if (!Number.isFinite(current)) return;
      const value = window.SmoofLayerOpacityTools.set(
        itemId,
        current + (action.endsWith('plus') ? 0.05 : -0.05)
      );
      const output = panel.querySelector('[data-smoof-ui-opacity-value]');
      if (output) output.textContent = `${Math.round(value * 100)}%`;
      scheduleHistoryCapture(80);
      return;
    }
    if (action === 'logo-invert' || action === 'logo-copy-invert' || action === 'logo-2-invert') {
      const logoId = action === 'logo-2-invert' ? 'logo-2' : action === 'logo-copy-invert' ? 'logo-copy' : 'logo';
      window.SmoofLogoInvertTools?.toggle?.(logoId);
      selectedId = logoId;
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'logo-copy-toggle') {
      const enabled = window.SmoofLogoCopyTools?.toggleEnabled?.();
      selectedId = enabled ? 'logo-copy' : 'logo';
      if (enabled) dispatchSelection('logo-copy');
      else dispatchSelection('logo');
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'logo-copy-minus' || action === 'logo-copy-plus') {
      window.SmoofLogoCopyTools?.adjustScale?.(action.endsWith('plus') ? 0.1 : -0.1);
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'logo-copy-reset') {
      window.SmoofLogoCopyTools?.resetPosition?.();
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'logo-2-open') {
      selectedId = 'logo-2';
      if (layersOpen) layersPage = 'detail';
      dispatchSelection('logo-2');
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'logo-2-minus' || action === 'logo-2-plus') {
      window.SmoofLogoDuplicateTools?.adjustScale?.(action.endsWith('plus') ? 0.1 : -0.1);
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'logo-2-reset') {
      window.SmoofLogoDuplicateTools?.resetPosition?.();
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'logo-2-file') {
      const logo = window.SmoofLogoDuplicateTools?.getState?.() || {};
      if (logo.hasLogo) window.SmoofLogoDuplicateTools?.remove?.();
      else window.SmoofLogoDuplicateTools?.openUpload?.();
      selectedId = 'logo-2';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 80);
      return;
    }
    if (action === 'logo-reset') {
      window.SmoofLogoTools?.resetPosition?.();
      selectedId = itemId;
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'logo-file') {
      const logo = window.SmoofLogoTools?.getState?.() || {};
      if (logo.hasLogo) window.SmoofLogoTools?.remove?.();
      else window.SmoofLogoTools?.openUpload?.();
      selectedId = 'logo';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 80);
      return;
    }
    if (action === 'logo-background-toggle') {
      window.SmoofLogoBackgroundTools?.toggle?.(itemId);
      selectedId = itemId;
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'logo-background-padding-minus' || action === 'logo-background-padding-plus') {
      const background = window.SmoofLogoBackgroundTools?.get?.(itemId);
      if (!background) return;
      const value = window.SmoofLogoBackgroundTools.setPadding(
        itemId,
        background.padding + (action.endsWith('plus') ? 0.05 : -0.05)
      );
      const output = panel.querySelector('[data-smoof-ui-logo-padding-value]');
      if (output) output.textContent = `${Math.round(value * 100)}%`;
      scheduleHistoryCapture(80);
      return;
    }
    if (action === 'nfc-transparency') {
      window.SmoofNfcTools?.toggleTransparency?.();
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 60);
      return;
    }
    if (action === 'pill-toggle' || action === 'pill-fill-toggle') {
      if (itemId === 'table-number') {
        if (action === 'pill-toggle') window.SmoofNumberHistory?.togglePill?.();
        else window.SmoofNumberHistory?.togglePillFill?.();
        selectedId = itemId;
        scheduleHistoryCapture(80);
        setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
        return;
      }
      if (/^custom-text-[1-3]$/.test(itemId)) {
        if (action === 'pill-toggle') window.SmoofCustomTextTools?.togglePill?.(itemId);
        else window.SmoofCustomTextTools?.togglePillFill?.(itemId);
        selectedId = itemId;
        setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
        return;
      }
      const index = Number(itemId.split('-')[1]);
      if (action === 'pill-toggle') window.SmoofTextTools?.togglePill?.(index);
      else window.SmoofTextTools?.togglePillFill?.(index);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (/^pill-(stroke|padding-x|padding-y)-(minus|plus)$/.test(action)) {
      const kind = action.includes('padding-x') ? 'paddingX' : action.includes('padding-y') ? 'paddingY' : 'stroke';
      const step = kind === 'stroke' ? 0.01 : 0.05;
      if (itemId === 'table-number') {
        window.SmoofNumberHistory?.adjustPill?.(kind, action.endsWith('plus') ? step : -step);
      } else if (/^custom-text-[1-3]$/.test(itemId)) {
        window.SmoofCustomTextTools?.adjustPill?.(itemId, kind, action.endsWith('plus') ? step : -step);
      } else {
        const index = Number(itemId.split('-')[1]);
        window.SmoofTextTools?.adjustPill?.(index, kind, action.endsWith('plus') ? step : -step);
      }
      selectedId = itemId;
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'nfc-reset') {
      window.SmoofNfcTools?.resetPosition?.();
      return;
    }
    if (action === 'payment-size-minus' || action === 'payment-size-plus') {
      const paymentState = window.SmoofPaymentTools?.getState?.();
      if (!paymentState) return;
      const value = window.SmoofPaymentTools.setScale(
        paymentState.scale + (action.endsWith('plus') ? 0.1 : -0.1)
      );
      const output = panel.querySelector('[data-smoof-ui-payment-scale]');
      if (output) output.textContent = `${Math.round(value * 100)}%`;
      scheduleHistoryCapture(80);
      return;
    }
    if (action === 'payment-reset') {
      window.SmoofPaymentTools?.resetPosition?.();
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'social-platform-size-minus' || action === 'social-platform-size-plus') {
      const object = window.SmoofSocialPlatformTools?.getObject?.(itemId);
      if (!object) return;
      window.SmoofSocialPlatformTools.setScale(itemId, object.scale + (action.endsWith('plus') ? .1 : -.1));
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'social-platform-opacity-minus' || action === 'social-platform-opacity-plus') {
      const object = window.SmoofSocialPlatformTools?.getObject?.(itemId);
      if (!object) return;
      window.SmoofSocialPlatformTools.setOpacity(itemId, object.opacity + (action.endsWith('plus') ? .05 : -.05));
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'social-platform-reset') {
      window.SmoofSocialPlatformTools?.resetPosition?.(itemId);
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'social-platform-delete') {
      window.SmoofSocialPlatformTools?.setEnabled?.(itemId, false);
      selectedId = 'social-library';
      dispatchSelection('social-library', { openContext: true });
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'arrows-reset') {
      window.SmoofArrowTools?.resetPosition?.(itemId.split('-')[1]);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-text-minus' || action === 'custom-text-plus') {
      window.SmoofCustomTextTools?.adjustScale?.(itemId, action.endsWith('plus') ? 0.1 : -0.1);
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'custom-text-reset') {
      window.SmoofCustomTextTools?.resetPosition?.(itemId);
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'custom-text-delete') {
      window.SmoofCustomTextTools?.remove?.(itemId);
      selectedId = 'add';
      dispatchSelection('add', { openContext: true });
      if (layersOpen) layersPage = 'list';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'custom-pictogram-minus' || action === 'custom-pictogram-plus') {
      window.SmoofCustomPictogramTools?.adjustScale?.(itemId, action.endsWith('plus') ? 0.1 : -0.1);
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'custom-pictogram-rotation-minus' || action === 'custom-pictogram-rotation-plus') {
      const state = window.SmoofCustomPictogramTools?.getState?.(itemId);
      if (!state) return;
      window.SmoofCustomPictogramTools.setRotation(itemId, Number(state.rotation || 0) + (action.endsWith('plus') ? 15 : -15));
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-pictogram-mirror') {
      window.SmoofCustomPictogramTools?.toggleMirror?.(itemId);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-pictogram-reset') {
      window.SmoofCustomPictogramTools?.resetPosition?.(itemId);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-pictogram-delete') {
      window.SmoofCustomPictogramTools?.remove?.(itemId);
      selectedId = 'add';
      dispatchSelection('add', { openContext: true });
      if (layersOpen) layersPage = 'list';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'arrow-scale-minus' || action === 'arrow-scale-plus') {
      const side = itemId.split('-')[1];
      const state = window.SmoofArrowTools?.getState?.(side);
      if (!state) return;
      window.SmoofArrowTools?.setScale?.(
        side,
        (Number(state.scale) || 1) + (action.endsWith('plus') ? 0.1 : -0.1)
      );
      selectedId = itemId;
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (/^arrow-(rotation|count)-(minus|plus)$/.test(action)) {
      const side = itemId.split('-')[1];
      const state = window.SmoofArrowTools?.getState?.(side);
      if (!state) return;
      if (action.startsWith('arrow-rotation')) {
        window.SmoofArrowTools.setRotation(side, state.rotation + (action.endsWith('plus') ? 15 : -15));
      } else {
        window.SmoofArrowTools.setCount(side, state.count + (action.endsWith('plus') ? 1 : -1));
      }
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'arrow-label') {
      window.SmoofArrowTools?.toggleLabel?.(itemId.split('-')[1]);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-upload') {
      if (!window.SmoofBackgroundImageBridge?.openPicker?.()) {
        window.SmoofBackgroundImageTools?.openPicker?.();
      }
      return;
    }
    if (action === 'background-gradient-toggle') {
      window.SmoofBackgroundGradientTools?.toggle?.();
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (/^background-image-(?:scale|x|y)-(?:minus|plus)$/.test(action)) {
      const bridge = window.SmoofBackgroundImageBridge;
      const image = bridge?.getState?.();
      if (!image?.hasImage) return;
      const direction = action.endsWith('plus') ? 1 : -1;
      if (action.includes('-scale-')) {
        const currentScale = Math.max(0.05, Math.min(3, Number(image.scale) || 1));
        const step = currentScale < 0.1 ? 0.05 : 0.1;
        bridge.setScale?.(currentScale + direction * step);
      }
      const positionX = Number.isFinite(Number(image.positionX)) ? Number(image.positionX) : 0.5;
      const positionY = Number.isFinite(Number(image.positionY)) ? Number(image.positionY) : 0.5;
      if (action.includes('-x-')) bridge.setPosition?.(positionX + direction * 0.05, positionY);
      if (action.includes('-y-')) bridge.setPosition?.(positionX, positionY + direction * 0.05);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-image-position-reset') {
      window.SmoofBackgroundImageBridge?.resetPlacement?.();
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-gradient-angle-minus' || action === 'background-gradient-angle-plus') {
      const gradient = window.SmoofBackgroundGradientTools?.getState?.();
      if (!gradient) return;
      window.SmoofBackgroundGradientTools.setAngle(
        gradient.angle + (action.endsWith('plus') ? 15 : -15)
      );
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-overlay-toggle') {
      window.SmoofBackgroundGradientTools?.toggleOverlay?.();
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-overlay-opacity-minus' || action === 'background-overlay-opacity-plus') {
      const gradient = window.SmoofBackgroundGradientTools?.getState?.();
      if (!gradient) return;
      window.SmoofBackgroundGradientTools.setOverlayOpacity(
        gradient.overlayOpacity + (action.endsWith('plus') ? 0.1 : -0.1)
      );
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-remove') {
      if (window.SmoofBackgroundImageBridge?.remove) {
        window.SmoofBackgroundImageBridge.remove();
      } else {
        window.SmoofBackgroundImageTools?.remove?.();
      }
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 60);
      return;
    }
    if (action === 'item-visibility') {
      suppressSelectionRenderId = itemId;
      suppressSelectionRenderUntil = Date.now() + 500;
      toggleVisibility(itemId);
      selectedId = itemId;
      setTimeout(() => {
        const button = panel.querySelector('[data-smoof-ui-action="item-visibility"]');
        const visible = isVisible(itemId);
        if (button) {
          button.innerHTML = icon(visible ? 'eye' : 'eyeOff');
          button.setAttribute(
            'aria-label',
            visible ? t('Element ausblenden', 'Hide element') : t('Element einblenden', 'Show element')
          );
        }
      }, 60);
      return;
    } else if (map[action]) {
      suppressSelectionRenderId = itemId;
      suppressSelectionRenderUntil = Date.now() + 800;
      const native = targetSource?.querySelector(map[action]);
      if (native && !native.disabled) native.click();
      selectedId = itemId;
      if (/^(text|logo|number)-(minus|plus|reset)$/.test(action)) {
        const update = () => syncScaleReadout(panel, itemId);
        requestAnimationFrame(() => {
          update();
          requestAnimationFrame(update);
        });
        setTimeout(update, 90);
      }
      return;
    }
    selectedId = itemId;
    dispatchSelection(itemId);
    if (action !== 'text-font') setTimeout(() => layersOpen ? renderLayers() : renderContext(), 80);
  }

  function bindPanel(panel) {
    let pointerTarget = null;
    let pointerTime = 0;
    let touchPointerId = null;
    let touchTarget = null;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchMoved = false;
    let suppressTouchClickUntil = 0;
    const panelControlSelector = [
      '[data-smoof-ui-action]',
      '[data-smoof-ui-panel-close]',
      '[data-smoof-ui-panel-back]',
      'button[data-smoof-ui-layer-action]',
      '[data-smoof-ui-payment-option]',
      '[data-smoof-ui-layer]'
    ].join(', ');

    function runPanelControl(target) {
      const paymentOption = target.closest('[data-smoof-ui-payment-option]');
      if (paymentOption) {
        const payment = paymentOption.querySelector('[data-smoof-ui-payment-provider]');
        if (!payment || payment.disabled) return false;
        payment.checked = !payment.checked;
        payment.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      if (panel === layers && layersPage === 'list') {
        const visibility = target.closest('button[data-smoof-ui-layer-action]');
        if (visibility) {
          toggleVisibility(visibility.dataset.smoofUiLayerAction);
          setTimeout(renderLayers, 70);
          return true;
        }
        const layer = target.closest('[data-smoof-ui-layer]');
        if (layer && layer.dataset.editable === 'true') {
          openLayer(layer.dataset.smoofUiLayer);
          return true;
        }
      }
      const close = target.closest('[data-smoof-ui-panel-close]');
      if (close) {
        if (panel === layers) setLayersOpen(false); else dispatchSelection('');
        return true;
      }
      if (target.closest('[data-smoof-ui-panel-back]')) {
        layersPage = 'list';
        startLayersTransition('back');
        renderLayers();
        return true;
      }
      const action = target.closest('[data-smoof-ui-action]');
      if (action) {
        handleAction(action.dataset.smoofUiAction, panel);
        return true;
      }
      return false;
    }

    panel.addEventListener('pointerdown', event => {
      const control = event.target.closest(panelControlSelector);

      if (event.pointerType === 'touch') {
        touchPointerId = event.pointerId;
        touchTarget = control;
        touchStartX = event.clientX;
        touchStartY = event.clientY;
        touchMoved = false;
        pointerTarget = null;
        event.stopPropagation();
        return;
      }

      if (control && runPanelControl(control)) {
        pointerTarget = control;
        pointerTime = Date.now();
        event.preventDefault();
      }
      event.stopPropagation();
    });

    panel.addEventListener('pointermove', event => {
      if (event.pointerId !== touchPointerId) return;
      const distance = Math.hypot(
        event.clientX - touchStartX,
        event.clientY - touchStartY
      );
      if (distance > 8) {
        touchMoved = true;
        suppressTouchClickUntil = Date.now() + 450;
      }
      event.stopPropagation();
    });

    panel.addEventListener('pointerup', event => {
      if (event.pointerId !== touchPointerId) return;
      const releaseTarget = event.target.closest(panelControlSelector);
      const sameControl = touchTarget && (
        releaseTarget === touchTarget ||
        touchTarget.contains(releaseTarget) ||
        releaseTarget?.contains(touchTarget)
      );
      const shouldRun = !touchMoved && sameControl;
      const control = touchTarget;

      touchPointerId = null;
      touchTarget = null;
      suppressTouchClickUntil = Date.now() + 450;

      if (shouldRun && runPanelControl(control)) event.preventDefault();
      event.stopPropagation();
    });

    panel.addEventListener('pointercancel', event => {
      if (event.pointerId !== touchPointerId) return;
      touchPointerId = null;
      touchTarget = null;
      touchMoved = true;
      suppressTouchClickUntil = Date.now() + 450;
    });

    panel.addEventListener('click', event => {
      const control = event.target.closest(panelControlSelector);
      if (Date.now() < suppressTouchClickUntil) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (
        control &&
        control === pointerTarget &&
        Date.now() - pointerTime < 800
      ) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (control && runPanelControl(control)) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
    panel.addEventListener('input', event => {
      const hexInput = event.target.closest('[data-smoof-ui-hex-color]');
      if (hexInput) {
        applyHexColor(hexInput, false, panel);
        return;
      }
      const input = event.target.closest('[data-smoof-ui-color]');
      if (input) applyColor(input.dataset.smoofUiColor, input.value, false, panel);
    });
    panel.addEventListener('change', event => {
      const hexInput = event.target.closest('[data-smoof-ui-hex-color]');
      if (hexInput) {
        applyHexColor(hexInput, true, panel);
        return;
      }
      const customPictogramUpload = event.target.closest('[data-smoof-ui-custom-pictogram-upload]');
      if (customPictogramUpload) {
        const file = customPictogramUpload.files?.[0];
        if (!file) return;
        const status = panel.querySelector('[data-smoof-ui-pictogram-status]');
        const itemId = customPictogramUpload.dataset.smoofUiCustomPictogramUpload;
        const isSvg = /\.svg$/i.test(file.name || '') || file.type === 'image/svg+xml';
        const isPng = /\.png$/i.test(file.name || '') || file.type === 'image/png';
        const sizeValid = isSvg ? file.size <= 600000 : isPng ? file.size <= 500000 : false;
        if ((!isSvg && !isPng) || !sizeValid) {
          if (status) status.textContent = (!isSvg && !isPng)
            ? t('Bitte eine SVG- oder PNG-Datei auswählen.', 'Please select an SVG or PNG file.')
            : isPng
              ? t('Die PNG-Datei darf maximal 500 KB groß sein.', 'The PNG file may not exceed 500 KB.')
              : t('Die SVG-Datei darf maximal 600 KB groß sein.', 'The SVG file may not exceed 600 KB.');
          customPictogramUpload.value = '';
          return;
        }
        if (status) status.textContent = isPng ? t('PNG wird geprüft …', 'Checking PNG …') : t('SVG wird geprüft …', 'Checking SVG …');
        const readFile = isPng
          ? new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => resolve(String(reader.result || ''));
              reader.onerror = reject;
              reader.readAsDataURL(file);
            }).then(dataUrl => new Promise((resolve, reject) => {
              const image = new Image();
              image.onload = () => resolve({ dataUrl, width: image.naturalWidth || image.width, height: image.naturalHeight || image.height });
              image.onerror = reject;
              image.src = dataUrl;
            }))
          : file.text();
        Promise.resolve(readFile).then(fileData => {
          if (isPng && (fileData.width > 1000 || fileData.height > 1000)) {
            if (status) status.textContent = t('Das PNG darf maximal 1.000 × 1.000 Pixel groß sein.', 'The PNG may not exceed 1,000 × 1,000 pixels.');
            return;
          }
          const fileName = file.name.replace(/\.(?:svg|png)$/i, '');
          const applied = isPng
            ? window.SmoofCustomPictogramTools?.setCustomRaster?.(itemId, fileData.dataUrl, fileName, fileData.width, fileData.height)
            : window.SmoofCustomPictogramTools?.setCustomSymbol?.(itemId, fileData, fileName);
          if (!applied) {
            if (status) status.textContent = t('Diese Datei konnte nicht als Piktogramm verwendet werden.', 'This file could not be used as a pictogram.');
            return;
          }
          pictogramPickerCategory[itemId] = 'custom';
          pictogramPickerOpenFor = '';
          selectedId = itemId;
          scheduleHistoryCapture(120);
          setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
        }).catch(() => {
          if (status) status.textContent = t('Die Datei konnte nicht gelesen werden.', 'The file could not be read.');
        }).finally(() => { customPictogramUpload.value = ''; });
        return;
      }
      const pictogramUpload = event.target.closest('[data-smoof-ui-pictogram-upload]');
      if (pictogramUpload) {
        const file = pictogramUpload.files?.[0];
        if (!file) return;
        const status = panel.querySelector('[data-smoof-ui-pictogram-status]');
        const side = pictogramUpload.dataset.smoofUiPictogramUpload === 'right' ? 'right' : 'left';
        const isSvg = /\.svg$/i.test(file.name || '') || file.type === 'image/svg+xml';
        const isPng = /\.png$/i.test(file.name || '') || file.type === 'image/png';
        const sizeValid = isSvg ? file.size <= 600000 : isPng ? file.size <= 500000 : false;
        if ((!isSvg && !isPng) || !sizeValid) {
          if (status) status.textContent = (!isSvg && !isPng)
            ? t('Bitte eine SVG- oder PNG-Datei auswählen.', 'Please select an SVG or PNG file.')
            : isPng
              ? t('Die PNG-Datei darf maximal 500 KB groß sein.', 'The PNG file may not exceed 500 KB.')
              : t('Die SVG-Datei darf maximal 600 KB groß sein.', 'The SVG file may not exceed 600 KB.');
          pictogramUpload.value = '';
          return;
        }
        if (status) status.textContent = isPng
          ? t('PNG wird geprüft …', 'Checking PNG …')
          : t('SVG wird geprüft …', 'Checking SVG …');
        const readFile = isPng
          ? new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => resolve(String(reader.result || ''));
              reader.onerror = reject;
              reader.readAsDataURL(file);
            }).then(dataUrl => new Promise((resolve, reject) => {
              const image = new Image();
              image.onload = () => resolve({
                dataUrl,
                width: image.naturalWidth || image.width,
                height: image.naturalHeight || image.height
              });
              image.onerror = reject;
              image.src = dataUrl;
            }))
          : (typeof file.text === 'function'
              ? file.text()
              : new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onload = () => resolve(String(reader.result || ''));
                  reader.onerror = reject;
                  reader.readAsText(file);
                }));
        Promise.resolve(readFile).then(fileData => {
          if (isPng && (fileData.width > 1000 || fileData.height > 1000)) {
            if (status) status.textContent = t(
              'Das PNG darf maximal 1.000 × 1.000 Pixel groß sein.',
              'The PNG may not exceed 1,000 × 1,000 pixels.'
            );
            return;
          }
          const fileName = file.name.replace(/\.(?:svg|png)$/i, '');
          const applied = isPng
            ? window.SmoofArrowTools?.setCustomRaster?.(
                side,
                fileData.dataUrl,
                fileName,
                fileData.width,
                fileData.height
              )
            : window.SmoofArrowTools?.setCustomSymbol?.(side, fileData, fileName);
          if (!applied) {
            if (status) status.textContent = t(
              'Diese Datei konnte nicht als Piktogramm verwendet werden.',
              'This file could not be used as a pictogram.'
            );
            return;
          }
          pictogramPickerCategory[side] = 'custom';
          pictogramPickerOpenFor = '';
          selectedId = `arrow-${side}`;
          scheduleHistoryCapture(120);
          setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
        }).catch(() => {
          if (status) status.textContent = t('Die Datei konnte nicht gelesen werden.', 'The file could not be read.');
        }).finally(() => { pictogramUpload.value = ''; });
        return;
      }
      const payment = event.target.closest('[data-smoof-ui-payment-provider]');
      if (payment) {
        window.SmoofPaymentTools?.setProvider?.(
          payment.dataset.smoofUiPaymentProvider,
          payment.checked
        );
        selectedId = 'payments';
        scheduleHistoryCapture(80);
      }
      const socialPlatform = event.target.closest('[data-smoof-ui-social-platform]');
      if (socialPlatform) {
        const id = socialPlatform.dataset.smoofUiSocialPlatform;
        window.SmoofSocialPlatformTools?.setEnabled?.(id, socialPlatform.checked);
        selectedId = 'social-library';
        scheduleHistoryCapture(80);
        dispatchSelection('social-library', { openContext: true });
        setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      }
      const select = event.target.closest('[data-smoof-ui-select]');
      if (select) applySelect(select.dataset.smoofUiSelect, select.value, panel);
      const input = event.target.closest('[data-smoof-ui-color]');
      if (input) applyColor(input.dataset.smoofUiColor, input.value, true, panel);
    });
  }

  function setLayersOpen(open) {
    layersOpen = Boolean(open);
    if (layersOpen) {
      closeLegacyHelp();
      closeLegacyReset();
      layersPage = 'list';
      delete layers.dataset.smoofUiTransition;
      context.dataset.open = 'false';
      layers.dataset.open = 'true';
      renderLayers();
    } else {
      layers.dataset.open = 'false';
      layersPage = 'list';
    }
    syncCommandbar();
  }

  function togglePaymentsShortcut() {
    if (!personalizedDesignSelected() || !window.SmoofPaymentTools) return;
    const shouldOpen = !(selectedId === 'payments' && context?.dataset.open === 'true');

    if (layersOpen) setLayersOpen(false);
    closeLegacyHelp();
    closeLegacyReset();

    if (!shouldOpen) {
      selectedId = '';
      source = null;
      if (context) context.dataset.open = 'false';
      dispatchSelection('');
      syncCommandbar();
      return;
    }

    selectedId = 'payments';
    source = sourceFor('payments');
    renderContext();
    dispatchSelection('payments', { openContext: true });
    syncCommandbar();

    requestAnimationFrame(() => {
      if (selectedId !== 'payments' || layersOpen) return;
      source = sourceFor('payments');
      renderContext();
      syncCommandbar();
    });
  }

  function toggleAddShortcut() {
    if (!personalizedDesignSelected()) return;
    const shouldOpen = !(selectedId === 'add' && context?.dataset.open === 'true');

    if (layersOpen) setLayersOpen(false);
    closeLegacyHelp();
    closeLegacyReset();

    if (!shouldOpen) {
      selectedId = '';
      source = null;
      if (context) context.dataset.open = 'false';
      dispatchSelection('');
      syncCommandbar();
      return;
    }

    dispatchSelection('');
    selectedId = 'add';
    source = commandbar;
    renderContext();
    syncCommandbar();
  }

  function openLayer(id) {
    if (id === 'table-number' && !visibleItemFor(id)) {
      const toggle = document.querySelector('[data-smoof-number-toggle]');
      if (toggle && !toggle.hidden) toggle.click();
    }
    layersPage = 'detail';
    selectedId = id;
    suppressSelectionRenderId = id;
    suppressSelectionRenderUntil = Date.now() + 500;
    startLayersTransition('forward');
    renderLayers();
    dispatchSelection(id);
  }

  function startLayersTransition(direction) {
    if (!layers) return;
    clearTimeout(layersTransitionTimer);
    layers.dataset.smoofUiTransition = direction;
    layersTransitionTimer = setTimeout(() => {
      if (layers) delete layers.dataset.smoofUiTransition;
    }, mobile.matches ? 570 : 480);
  }

  function templateCoachmarkWasSeen() {
    if (templateCoachmarkAcknowledged) return true;
    try {
      return window.localStorage.getItem(TEMPLATE_COACHMARK_KEY) === 'seen';
    } catch (_error) {
      return false;
    }
  }

  function rememberTemplateCoachmark() {
    templateCoachmarkAcknowledged = true;
    try {
      window.localStorage.setItem(TEMPLATE_COACHMARK_KEY, 'seen');
    } catch (_error) {
      // The current page still stays dismissed when storage is unavailable.
    }
  }

  function positionTemplateCoachmark() {
    if (!templateCoachmark || templateCoachmark.hidden || !commandbar) return;
    const button = commandbar.querySelector('[data-smoof-ui-command-action="templates"]');
    if (!button) return;
    const anchor = button.getBoundingClientRect();
    const panel = templateCoachmark.getBoundingClientRect();
    const edge = 12;
    const gap = 13;
    const width = panel.width || 292;
    const height = panel.height || 230;
    const idealLeft = anchor.left + (anchor.width / 2) - (width / 2);
    const left = Math.max(edge, Math.min(idealLeft, window.innerWidth - width - edge));
    const fitsBelow = anchor.bottom + gap + height <= window.innerHeight - edge;
    const top = fitsBelow
      ? anchor.bottom + gap
      : Math.max(edge, anchor.top - height - gap);
    templateCoachmark.style.left = `${Math.round(left)}px`;
    templateCoachmark.style.top = `${Math.round(top)}px`;
    templateCoachmark.style.setProperty('--smoof-template-coachmark-arrow-x', `${Math.round(anchor.left + (anchor.width / 2) - left)}px`);
    templateCoachmark.dataset.placement = fitsBelow ? 'below' : 'above';
  }

  function dismissTemplateCoachmark(markSeen = true) {
    clearTimeout(templateCoachmarkTimer);
    templateCoachmarkTimer = 0;
    if (markSeen) rememberTemplateCoachmark();
    if (!templateCoachmark) return;
    templateCoachmark.dataset.open = 'false';
    templateCoachmark.hidden = true;
  }

  function ensureTemplateCoachmark() {
    if (templateCoachmark?.isConnected) return templateCoachmark;
    templateCoachmark = document.createElement('aside');
    templateCoachmark.dataset.smoofUiTemplateCoachmark = 'true';
    templateCoachmark.dataset.smoofEditorItem = 'modern-ui-control';
    templateCoachmark.dataset.open = 'false';
    templateCoachmark.hidden = true;
    templateCoachmark.setAttribute('role', 'dialog');
    templateCoachmark.setAttribute('aria-modal', 'false');
    templateCoachmark.setAttribute('aria-labelledby', 'smoof-template-coachmark-title');
    templateCoachmark.innerHTML = `<button type="button" data-smoof-ui-template-coachmark-close aria-label="${t('Hinweis schließen', 'Close hint')}">${icon('close')}</button><div data-smoof-ui-template-coachmark-preview aria-hidden="true"><span>${t('Order & Pay', 'Order & Pay')}</span><span>${t('Speisekarte', 'Menu')}</span><span>${t('Gästemappe', 'Guest directory')}</span></div><div data-smoof-ui-template-coachmark-body><span data-smoof-ui-template-coachmark-symbol>${icon('templates')}</span><div><strong id="smoof-template-coachmark-title">${t('Mit Vorlagen schneller starten', 'Start faster with templates')}</strong><p>${t('Wählen Sie ein vorbereitetes Design und passen Sie es direkt an Ihr Branding an.', 'Choose a prepared design and adapt it directly to your branding.')}</p></div><button type="button" data-smoof-ui-template-coachmark-open>${t('Vorlagen entdecken', 'Explore templates')}<span aria-hidden="true">→</span></button></div>`;
    templateCoachmark.addEventListener('pointerdown', event => event.stopPropagation());
    templateCoachmark.addEventListener('click', event => {
      if (event.target.closest('[data-smoof-ui-template-coachmark-close]')) {
        dismissTemplateCoachmark(true);
        return;
      }
      if (!event.target.closest('[data-smoof-ui-template-coachmark-open]')) return;
      dismissTemplateCoachmark(true);
      commandbar?.querySelector('[data-smoof-ui-command-action="templates"]')?.click();
    });
    document.body.append(templateCoachmark);
    return templateCoachmark;
  }

  function scheduleTemplateCoachmark() {
    if (
      templateCoachmarkTimer ||
      templateCoachmark?.dataset.open === 'true' ||
      templateCoachmarkWasSeen() ||
      !personalizedDesignSelected()
    ) return;
    templateCoachmarkTimer = window.setTimeout(() => {
      templateCoachmarkTimer = 0;
      if (templateCoachmarkWasSeen() || !personalizedDesignSelected()) return;
      const panel = ensureTemplateCoachmark();
      panel.hidden = false;
      panel.dataset.open = 'true';
      requestAnimationFrame(positionTemplateCoachmark);
    }, 900);
  }

  function ensureShell() {
    if (commandbar && commandbar.isConnected) return;
    commandbar = document.createElement('nav');
    commandbar.dataset.smoofUiCommandbar = 'true';
    commandbar.dataset.smoofEditorItem = 'modern-ui-control';
    commandbar.innerHTML = `<button type="button" data-smoof-ui-command-action="templates" aria-label="${t('Vorlagen', 'Templates')}" title="${t('Vorlagen', 'Templates')}" aria-expanded="false">${icon('templates')}</button><button type="button" data-smoof-ui-command-action="layers" aria-label="${t('Ebenen', 'Layers')}" title="${t('Ebenen', 'Layers')}" aria-expanded="false">${icon('layers')}</button><button type="button" data-smoof-ui-command-action="add" aria-label="${t('Hinzufügen', 'Add')}" title="${t('Hinzufügen', 'Add')}" aria-expanded="false">${icon('add')}</button><button type="button" data-smoof-ui-command-action="save-design" aria-label="${t('Uploads & Downloads', 'Uploads & Downloads')}" title="${t('Uploads & Downloads', 'Uploads & Downloads')}" aria-expanded="false">${icon('save')}</button><button type="button" data-smoof-ui-command-action="undo" aria-label="${t('Rückgängig', 'Undo')}" title="${t('Rückgängig', 'Undo')}">${icon('undo')}</button><button type="button" data-smoof-ui-command-action="redo" aria-label="${t('Wiederholen', 'Redo')}" title="${t('Wiederholen', 'Redo')}">${icon('redo')}</button><button type="button" data-smoof-ui-command-action="guides" aria-label="${t('Bemaßung und Hilfslinien', 'Measurements and guides')}" title="${t('Bemaßung und Hilfslinien', 'Measurements and guides')}">${icon('ruler')}</button><button type="button" data-smoof-ui-command-action="reset" aria-label="${t('Design zurücksetzen', 'Reset design')}" title="${t('Design zurücksetzen', 'Reset design')}">${icon('reset')}</button><button type="button" data-smoof-ui-command-action="help" aria-label="${t('Hilfe', 'Help')}" title="${t('Hilfe', 'Help')}">${icon('help')}</button>`;
    context = document.createElement('section');
    context.dataset.smoofUiContext = 'true';
    context.dataset.smoofEditorItem = 'modern-ui-control';
    context.dataset.open = 'false';
    layers = document.createElement('aside');
    layers.dataset.smoofUiLayers = 'true';
    layers.dataset.smoofEditorItem = 'modern-ui-control';
    layers.dataset.open = 'false';
    document.body.append(commandbar, context, layers);
    root.dataset.smoofUiShellReady = 'true';
    bindPanel(context);
    bindPanel(layers);

    commandbar.addEventListener('pointerdown', event => {
      event.stopPropagation();
    });
    commandbar.addEventListener('pointerup', event => {
      const addButton = event.target.closest('[data-smoof-ui-command-action="add"]');
      if (!addButton || (event.button !== undefined && event.button !== 0)) return;
      addShortcutPointerHandledUntil = Date.now() + 700;
      event.preventDefault();
      event.stopPropagation();
      toggleAddShortcut();
    });
    commandbar.addEventListener('click', event => {
      const button = event.target.closest('[data-smoof-ui-command-action]');
      if (!button) return;
      const action = button.dataset.smoofUiCommandAction;
      if (action === 'layers') { setLayersOpen(!layersOpen); return; }
      if (action === 'templates') {
        dismissTemplateCoachmark(true);
        const shouldOpen = selectedId !== 'templates' || context?.dataset.open !== 'true';
        closeLegacyHelp();
        closeLegacyReset();
        if (layersOpen) setLayersOpen(false);
        if (shouldOpen) {
          selectedId = 'templates';
          source = commandbar;
          renderContext();
        } else {
          dispatchSelection('');
        }
        syncCommandbar();
        return;
      }
      if (action === 'save-design') {
        const shouldOpen = selectedId !== 'downloads' || context?.dataset.open !== 'true';
        closeLegacyHelp();
        closeLegacyReset();
        if (layersOpen) setLayersOpen(false);
        if (shouldOpen) {
          selectedId = 'downloads';
          source = commandbar;
          renderContext();
        } else {
          dispatchSelection('');
        }
        syncCommandbar();
        return;
      }
      if (action === 'add') {
        if (Date.now() < addShortcutPointerHandledUntil) return;
        toggleAddShortcut();
        return;
      }
      if (action === 'undo') { undoHistory(); return; }
      if (action === 'redo') { redoHistory(); return; }
      if (action === 'help') {
        const shouldOpen = !helpWasOpenOnPointerDown;
        helpWasOpenOnPointerDown = false;
        if (shouldOpen) openLegacyHelp();
        else closeLegacyHelp();
        syncCommandbar();
        return;
      }
      if (action === 'reset') {
        const shouldOpen = !resetWasOpenOnPointerDown;
        resetWasOpenOnPointerDown = false;
        if (shouldOpen) openLegacyReset();
        else closeLegacyReset();
        syncCommandbar();
        return;
      }
      const selectors = { guides: '[data-smoof-guide-visibility-button]' };
      const native = document.querySelector(selectors[action]);
      if (native) native.click();
      setTimeout(() => {
        syncCommandbar();
        if (action === 'help') positionLegacyPopover(action);
      }, 80);
      helpWasOpenOnPointerDown = false;
      resetWasOpenOnPointerDown = false;
    });

    syncCommandbar();
  }

  window.addEventListener(SELECT_EVENT, event => {
    selectedId = String(event.detail && event.detail.id ? event.detail.id : '');
    if (
      mobile.matches &&
      !layersOpen &&
      event.detail?.openContext !== true
    ) {
      source = selectedId ? sourceFor(selectedId) : null;
      if (context) context.dataset.open = 'false';
      syncCommandbar();
      return;
    }
    if (
      selectedId === suppressSelectionRenderId &&
      Date.now() < suppressSelectionRenderUntil
    ) {
      return;
    }
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
      syncCommandbar();
    }, 0);
  });

  window.addEventListener('smoof:background-image-changed', () => {
    if (selectedId !== 'background') return;
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:qr-geometry-change', () => {
    if (selectedId !== 'qr') return;
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:custom-pictogram-change', () => {
    if (!/^custom-pictogram-[1-3]$/.test(selectedId) && !layersOpen && selectedId !== 'add') return;
    setTimeout(() => {
      if (layersOpen) renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:template-library-changed', () => {
    if (selectedId !== 'templates' || context?.dataset.open !== 'true') return;
    setTimeout(() => {
      renderContext();
      syncCommandbar();
    }, 0);
  });

  window.addEventListener('smoof:logo-file-changed', () => {
    if (selectedId !== 'logo') return;
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:logo-copy-ready', () => {
    if (selectedId !== 'logo') return;
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:logo-2-file-changed', () => {
    if (selectedId !== 'logo-2' && selectedId !== 'logo') return;
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
    }, 0);
  });

  ['smoof:logo-copy-changed', 'smoof:logo-background-changed'].forEach(eventName => {
    window.addEventListener(eventName, () => {
      if (!['logo', 'logo-copy', 'logo-2'].includes(selectedId)) return;
      setTimeout(() => {
        if (layersOpen && layersPage === 'detail') renderLayers();
        else renderContext();
      }, 0);
    });
  });

  window.addEventListener('smoof:editor-reset-content', () => {
    ['left', 'right'].forEach(side => {
      if (window.SmoofArrowTools?.isVisible?.(side) === false) {
        window.SmoofArrowTools?.toggleVisibility?.(side);
      }
    });
  });

  window.addEventListener('pointerdown', event => {
    const target = event.target instanceof Element ? event.target : null;
    const layersToggle = target?.closest('[data-smoof-ui-command-action="layers"]');
    const insideLayers = target?.closest('[data-smoof-ui-layers]');
    const canvasItem = target?.closest('[data-smoof-editor-item]');
    if (layersOpen && !layersToggle && !insideLayers && !canvasItem) setLayersOpen(false);

    const resetToggle = target?.closest('[data-smoof-ui-command-action="reset"], [data-smoof-reset-button]');
    const insideReset = target?.closest('[data-smoof-reset-menu]');
    if (legacyPanelOpen('reset') && !resetToggle && !insideReset) closeLegacyReset();

    if (target?.closest('[data-smoof-ui-command-action="help"]')) {
      helpWasOpenOnPointerDown = legacyPanelOpen('help');
    } else if (target?.closest('[data-smoof-ui-command-action="reset"]')) {
      resetWasOpenOnPointerDown = legacyPanelOpen('reset');
    } else if (legacyPanelOpen('help')) {
      setTimeout(syncCommandbar, 0);
    } else if (legacyPanelOpen('reset')) {
      setTimeout(syncCommandbar, 0);
    }
  }, true);

  document.addEventListener('pointerdown', event => {
    const target = event.target instanceof Element ? event.target : null;
    const editorItem = target?.closest('[data-smoof-editor-item]');
    const itemId = editorItem?.dataset.smoofEditorItem || '';
    const closestButton = target?.closest('button');
    const directControl = target?.closest('input, select, textarea, [data-smoof-ui-context], [data-smoof-ui-layers], [data-smoof-ui-commandbar]') ||
      (closestButton && closestButton !== editorItem);
    if (
      mobile.matches &&
      itemId &&
      descriptors()[itemId] &&
      !directControl
    ) {
      mobileCanvasPointer = {
        pointerId: event.pointerId,
        itemId,
        startX: event.clientX,
        startY: event.clientY,
        moved: false,
        wasSelected: selectedId === itemId,
        contextWasOpen: context?.dataset.open === 'true'
      };
      if (context) context.dataset.open = 'false';
    }
    const descriptor = itemId ? descriptors()[itemId] : null;
    const nestedControl = target?.closest([
      'input',
      'select',
      'textarea',
      '[data-smoof-text-controls]',
      '[data-smoof-logo-controls]',
      '[data-smoof-logo-copy-controls]',
      '[data-smoof-logo-duplicate-controls]',
      '[data-smoof-arrow-controls]',
      '[data-smoof-number-controls]',
      '[data-smoof-brand-controls]',
      '[data-smoof-ui-context]',
      '[data-smoof-ui-layers]',
      '[data-smoof-ui-commandbar]'
    ].join(','));
    const button = target?.closest('button');
    const canvasButton = button && button === editorItem;
    if (editorItem && descriptor && !descriptor.locked && !nestedControl && (!button || canvasButton)) {
      root.dataset.smoofUiDragging = 'true';
    }
  }, true);

  window.addEventListener('pointermove', event => {
    if (!mobileCanvasPointer || mobileCanvasPointer.pointerId !== event.pointerId) return;
    if (Math.hypot(
      event.clientX - mobileCanvasPointer.startX,
      event.clientY - mobileCanvasPointer.startY
    ) > 7) {
      mobileCanvasPointer.moved = true;
    }
  }, true);

  function finishMobileCanvasPointer(event, cancelled = false) {
    if (!mobileCanvasPointer || mobileCanvasPointer.pointerId !== event.pointerId) return;
    const interaction = mobileCanvasPointer;
    mobileCanvasPointer = null;
    if (cancelled || !interaction.wasSelected) return;
    setTimeout(() => {
      if (
        mobile.matches &&
        !layersOpen &&
        selectedId === interaction.itemId &&
        (!interaction.moved || interaction.contextWasOpen)
      ) {
        renderContext();
        syncCommandbar();
      }
    }, 0);
  }

  window.addEventListener('pointerup', event => finishMobileCanvasPointer(event), true);
  window.addEventListener('pointercancel', event => finishMobileCanvasPointer(event, true), true);

  const finishUiDrag = () => {
    root.removeAttribute('data-smoof-ui-dragging');
    scheduleHistoryCapture(180);
  };
  window.addEventListener('pointerup', finishUiDrag, true);
  window.addEventListener('pointercancel', finishUiDrag, true);
  window.addEventListener('blur', () => {
    mobileCanvasPointer = null;
    finishUiDrag();
  });

  window.addEventListener('resize', () => { positionCommandbar(); positionContext(); positionLayers(); positionLegacyPopover('help'); positionLegacyPopover('reset'); positionTemplateCoachmark(); });
  window.addEventListener('scroll', () => { positionCommandbar(); positionContext(); positionLayers(); positionLegacyPopover('help'); positionLegacyPopover('reset'); positionTemplateCoachmark(); }, true);
  window.addEventListener('smoof:product-variant-change', () => {
    if (layersOpen) renderLayers();
    else if (selectedId) renderContext();
    syncCommandbar();
  });

  let frame = 0;
  function reconcile() {
    frame = 0;
    ensureShell();
    syncPersonalizationGate();
    syncCommandbar();
    if (selectedId && source && !source.isConnected) {
      source = sourceFor(selectedId);
      const visibilityTransition =
        selectedId === suppressSelectionRenderId &&
        Date.now() < suppressSelectionRenderUntil;
      if (!visibilityTransition) {
        if (layersOpen && layersPage === 'detail') renderLayers(); else renderContext();
      }
    }
  }
  const observer = new MutationObserver(() => {
    if (frame) return;
    frame = requestAnimationFrame(reconcile);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  const fontPickerCloseObserver = new MutationObserver(records => {
    if (!fontPickerTarget) return;
    const pickerClosed = records.some(record =>
      record.target instanceof Element &&
      record.target.matches('.smoof-font-backdrop') &&
      record.target.dataset.open === 'false'
    );
    if (!pickerClosed) return;
    setTimeout(() => {
      if (!fontPickerTarget) return;
      if (document.querySelector('.smoof-font-backdrop[data-open="true"]')) return;
      resetFontPickerState();
    }, 0);
  });
  fontPickerCloseObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['data-open'],
    subtree: true
  });
  function detectFontSelection(event) {
    if (!fontPickerTarget) return;
    const changed = event?.target instanceof Element ? event.target : null;
    const fontOption = optionRoot(FONT_OPTION_ID);
    if (changed && fontOption && !fontOption.contains(changed)) return;
    const family = selectedGoogleFont();
    if (!family) return;
    const explicitSelection = Boolean(changed?.matches?.('select, input[type="hidden"]'));
    if (family !== fontPickerInitialFamily || explicitSelection) finishFontSelection(family);
  }

  window.addEventListener('smoof:font-selected', event => {
    if (!fontPickerTarget) return;
    const family = cleanFontFamily(event.detail?.font);
    if (family) finishFontSelection(family);
  });

  window.setInterval(() => {
    if (!fontPickerTarget) return;
    const family = selectedGoogleFont();
    if (family && family !== fontPickerInitialFamily) finishFontSelection(family);
  }, 180);

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !fontPickerTarget) return;
    fontPickerTarget = '';
    fontPickerInitialFamily = '';
    root.removeAttribute('data-smoof-font-picker-active');
    setTimeout(() => layersOpen ? renderLayers() : renderContext(), 0);
  }, true);

  document.addEventListener('input', event => {
    detectFontSelection(event);
    scheduleHistoryCapture(380);
  }, true);
  document.addEventListener('change', event => {
    const changed = event.target instanceof Element ? event.target : null;
    detectFontSelection(event);
    scheduleHistoryCapture(320);
    if (changed?.matches('input[type="file"]')) scheduleHistoryCapture(1400);
    setTimeout(() => {
      syncPersonalizationGate();
      syncCommandbar();
    }, 40);
  }, true);
  document.addEventListener('click', () => scheduleHistoryCapture(260), true);

  function tourAnchor(name) {
    const command = action => commandbar?.querySelector(`[data-smoof-ui-command-action="${action}"]`) || null;
    const anchors = {
      workspace: () => commandbarAnchor(),
      templates: () => context?.dataset.open === 'true' && selectedId === 'templates' ? context : command('templates'),
      layers: () => layers?.dataset.open === 'true' ? layers : command('layers'),
      add: () => context?.dataset.open === 'true' && selectedId === 'add' ? context : command('add'),
      downloads: () => context?.dataset.open === 'true' && selectedId === 'downloads' ? context : command('save-design'),
      safety: () => commandbar,
      surfaces: () => document.querySelector('[data-smoof-surface-switcher]:not([data-smoof-single-surface-presentation])'),
      views: () => document.querySelector('[data-smoof-qhs-3d-toggle]'),
      help: () => command('help')
    };
    return anchors[name]?.() || null;
  }

  function captureTourUi() {
    return {
      selectedId,
      layersOpen,
      layersPage,
      contextOpen: context?.dataset.open === 'true',
      helpOpen: legacyPanelOpen('help'),
      resetOpen: legacyPanelOpen('reset'),
      focus: document.activeElement instanceof HTMLElement ? document.activeElement : null
    };
  }

  function closeTourPanels() {
    closeLegacyHelp();
    closeLegacyReset();
    if (layersOpen) setLayersOpen(false);
    if (context) context.dataset.open = 'false';
  }

  function prepareTourStep(name) {
    if (!personalizedDesignSelected()) return false;
    dismissTemplateCoachmark(true);
    closeTourPanels();

    if (name === 'templates' || name === 'add' || name === 'downloads') {
      selectedId = name;
      source = commandbar;
      renderContext();
    } else if (name === 'layers') {
      setLayersOpen(true);
    }

    syncCommandbar();
    return true;
  }

  function restoreTourUi(snapshot) {
    closeTourPanels();
    if (!snapshot || !personalizedDesignSelected()) {
      syncCommandbar();
      return;
    }

    selectedId = String(snapshot.selectedId || '');
    layersPage = snapshot.layersPage === 'detail' ? 'detail' : 'list';
    source = selectedId ? sourceFor(selectedId) : null;

    if (snapshot.layersOpen) {
      layersOpen = true;
      layers.dataset.open = 'true';
      renderLayers();
    } else if (snapshot.contextOpen && selectedId) {
      renderContext();
    }

    if (snapshot.helpOpen) openLegacyHelp();
    else if (snapshot.resetOpen) openLegacyReset();
    syncCommandbar();
  }

  window.SmoofEditorTourBridge = Object.freeze({
    version: '1.0.0',
    enabled: personalizedDesignSelected,
    captureUi: captureTourUi,
    restoreUi: restoreTourUi,
    prepareStep: prepareTourStep,
    resolveAnchor: tourAnchor,
    closePanels: closeTourPanels,
    surfaceCount: () => Number(profile?.surfaceCount || root.dataset.smoofSurfaceCount || 1),
    hasThreeQuarter: () => Boolean(profile?.scene?.presentation?.views?.includes?.('threeQuarter') || tourAnchor('views'))
  });
  window.dispatchEvent(new CustomEvent('smoof:editor-tour-bridge-ready'));

  /*
   * Versionierte Zustandsgrenze fuer Produkte mit mehreren Druckflaechen.
   * Die einzelnen Editormodule bleiben Singletons; ein Surface-Controller
   * speichert und aktiviert genau einen vollstaendigen Snapshot zur Zeit.
   */
  window.SmoofEditorState = Object.freeze({
    version: '1.0.0',
    capture: captureHistorySnapshot,
    apply: applyHistorySnapshot,
    resetHistory() {
      clearHistory();
      historyBaselineTimer = setTimeout(() => {
        historyBaselineTimer = 0;
        commitHistorySnapshot();
      }, 320);
    },
    deselect() {
      window.dispatchEvent(new CustomEvent('smoof:editor-select', { detail: { id: '' } }));
    }
  });

  ensureShell();
  syncPersonalizationGate();
  if (personalizedDesignSelected() && !historyCurrent) {
    historyBaselineTimer = setTimeout(() => {
      historyBaselineTimer = 0;
      commitHistorySnapshot();
    }, 420);
  }
})();
